<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-12">
        <h4 class="text-back d-flex align-items-center mb-0">
          <i
            class="fa fa-chevron-circle-left pe-2"
            aria-hidden="true"
            @click="backBanchesList()"
            style="cursor: pointer"
          ></i>
          <span
            @click="backBanchesList()"
            style="cursor: pointer"
          >
            BACK
          </span>
        </h4>
      </div>
    </div>

    <div
      class="page-header align-items-start min-vh-100 my-transacions branch-detail"
    >
      <div class="container-fluid px-3 px-md-4">
        <div class="row card-custom-new pt-3">
          <div class="col-12 mx-auto pb-5">
            <!-- Page Title + Status -->
            <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
              <h3 class="title-page mb-0">
                {{
                  !this.$route.params.id
                    ? "CREATE SALE CHANNEL"
                    : "SALE CHANNEL DETAILS - " +
                      branch.branch_name.toLocaleUpperCase()
                }}
              </h3>
              <span
                v-if="this.$route.params.id"
                :class="
                  branch.status
                    ? 'badge badge-sm bg-gradient-success'
                    : 'badge badge-sm bg-gradient-danger'
                "
              >
                {{ branch.status ? "Active" : "Deactive" }}
              </span>
            </div>

            <!-- Created info + Action buttons -->
            <div
              class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-2 mb-3"
            >
              <div class="text-title">
                {{ branch.id ? "Created on " : "Create on "
                }}{{ branchCreateAt + " by " + branchCreateBy + " admin" }}
              </div>
              <div class="d-flex gap-2 flex-shrink-0">
                <material-button
                  @click="saveBranch(index)"
                  :disabled="disableBtnSubmit"
                  class="btn-background btn-sm"
                  >Save</material-button
                >
                <material-button
                  @click="changeStatus()"
                  v-if="this.$route.params.id"
                  class="btn-background btn-sm"
                >
                  {{ branch.status ? "Deactive" : "Active" }}
                </material-button>
              </div>
            </div>

            <!-- ── FORM FIELDS ── -->
            <div class="form-fields">
              <!-- Physical Branch -->
              <div class="field-row">
                <div class="field-label">
                  Physical Branch <span class="text-danger">*</span>
                </div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.physical_branch_id"
                    :options="physicalBranches"
                    placeholder="Select Physical Branch"
                    :canClear="false"
                    class="menuset-select"
                  />
                  <span
                    class="is-invalid"
                    v-if="fieldRequired.isPhysicalBranchRequire"
                    >The field is required.</span
                  >
                </div>
              </div>

              <!-- SF307: leave this channel out of /{merchant}/physical-branch/order -->
              <div class="field-row">
                <div class="field-label">Hide under outlet list</div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.hide_on_outlet_list"
                      name="hide_on_outlet_list"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.hide_on_outlet_list"
                      name="hide_on_outlet_list"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- Sale Channel Code -->
              <div class="field-row">
                <div class="field-label">
                  Sale Channel Code <span class="text-danger">*</span>
                </div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="branch_code"
                    v-model="branch.branch_code"
                    name="branch_code"
                    class="branch-address"
                    placeholder="Enter branch code"
                  />
                  <span
                    class="is-invalid"
                    v-if="fieldRequired.isBranchCodeRequire"
                    >The field is required.</span
                  >
                </div>
              </div>

              <!-- Sale Channel Name -->
              <div class="field-row">
                <div class="field-label">
                  Sale Channel Name <span class="text-danger">*</span>
                </div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="branch_name"
                    v-model="branch.branch_name"
                    name="branch_name"
                    class="branch-address"
                    placeholder="Enter sale channel name"
                  />
                  <span
                    class="is-invalid"
                    v-if="fieldRequired.isBranchNameRequire"
                    >The field is required.</span
                  >
                </div>
              </div>

              <!-- Profile Picture -->
              <div class="field-row">
                <div class="field-label">Profile Picture</div>
                <div class="field-value">
                  <div class="d-flex flex-wrap align-items-start gap-3">
                    <div>
                      <material-input
                        style="display: none"
                        type="file"
                        id="image"
                        @change="handleFileUpload($event)"
                        accept="image/*"
                      />
                      <material-button
                        @click="uploadFile()"
                        :disabled="false"
                        class="btn btn-sm capitalize btn-background"
                        >Upload Image</material-button
                      >
                      <div
                        class="is-invalid"
                        v-if="fieldRequired.isImageRequire"
                      >
                        {{ messageImageError }}
                      </div>
                      <div class="text-size-13">
                        Uploaded image minimum 200 x 115.
                      </div>
                    </div>
                    <div id="preview" style="position: relative">
                      <img
                        class="img-thumbnail"
                        v-if="urlImagePreview || branch.icon"
                        :src="urlImagePreview ? urlImagePreview : branch.icon"
                      />
                      <i
                        class="fa fa-times icon-close-sidenav-main danger"
                        v-if="urlImagePreview || branch.icon"
                        style="
                          position: absolute;
                          top: -8px;
                          left: 170px;
                          color: #f44335;
                          font-size: 20px;
                        "
                        aria-hidden="true"
                        @click="clearImage()"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SH001 — Address. Shown on the salon location picker in MOO; without
                   these inputs a Save posted branch_address: "" and wiped the address. -->
              <div class="field-row">
                <div class="field-label">Address</div>
                <div class="field-value">
                  <material-input
                    maxLength="255"
                    id="branch_address"
                    v-model="branch.branch_address"
                    name="branch_address"
                    class="branch-address"
                    placeholder="Enter street address"
                  />
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Unit No</div>
                <div class="field-value">
                  <material-input
                    maxLength="255"
                    id="unit_no"
                    v-model="branch.unit_no"
                    name="unit_no"
                    class="w-input-sm"
                    placeholder="#02-15"
                  />
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Postal Code</div>
                <div class="field-value">
                  <material-input
                    maxLength="255"
                    id="postal_code"
                    v-model="branch.postal_code"
                    name="postal_code"
                    class="w-input-sm"
                    placeholder="769098"
                  />
                </div>
              </div>

              <!-- GST Rate -->
              <div class="field-row">
                <div class="field-label">GST Rate (- for inclusive) %</div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="gst_rate"
                    v-model="branch.gst_rate"
                    name="gst_rate"
                    class="branch-address"
                    placeholder="Enter"
                  />
                </div>
              </div>

              <!-- Service Charge Rate -->
              <div class="field-row">
                <div class="field-label">Service Charge Rate %</div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="service_charge_rate"
                    v-model="branch.service_charge_rate"
                    name="service_charge_rate"
                    class="branch-address"
                    placeholder="Enter"
                  />
                </div>
              </div>

              <!-- Service Charge based on discounted subtotal (SF230) -->
              <div class="field-row">
                <div class="field-label">
                  Service Charge based on discounted subtotal (after discount)
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.service_charge_on_discounted_subtotal"
                      name="service_charge_on_discounted_subtotal"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.service_charge_on_discounted_subtotal"
                      name="service_charge_on_discounted_subtotal"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- Allow applying vouchers to the order (SF231) -->
              <div class="field-row">
                <div class="field-label">
                  Allow customers to apply vouchers to the order
                  <div class="text-xs text-secondary">
                    Customers can still earn cashback and view their vouchers
                  </div>
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.allow_apply_voucher"
                      name="allow_apply_voucher"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.allow_apply_voucher"
                      name="allow_apply_voucher"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- Max wallet/cashback deduct amount per order -->
              <div class="field-row">
                <div class="field-label">Max deduct amount per order</div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3 mb-2">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.max_deduct_type"
                      name="max_deduct_type"
                      >Percentage</MaterialRadio
                    >
                    <MaterialRadio
                      :value="2"
                      v-model="branch.max_deduct_type"
                      name="max_deduct_type"
                      >Fixed Amount</MaterialRadio
                    >
                  </div>
                  <div class="d-flex align-items-center">
                    <material-input
                      type="number"
                      maxLength="100"
                      id="max_deduct_value"
                      v-model="branch.max_deduct_value"
                      name="max_deduct_value"
                      class="branch-address"
                      placeholder="Enter"
                    />
                    <div class="ps-0 label-form d-flex align-items-end">
                      {{ branch.max_deduct_type == 1 ? "%" : "$" }}
                    </div>
                  </div>
                  <span class="is-invalid" v-if="fieldRequired.invalidMaxDeductValue"
                    >Please enter a valid number.</span
                  >
                </div>
              </div>

              <!-- Minty Online Ordering Color -->
              <div class="field-row">
                <div class="field-label">Minty Online Ordering Color</div>
                <div class="field-value">
                  <div class="d-flex align-items-center gap-3">
                    <color-input
                      v-model="branch.moo_color"
                      position="right bottom"
                    />
                    <!-- KSK109 -->
                    <input
                      :value="branch.moo_color"
                      type="text"
                      class="hex-input"
                      maxlength="7"
                      placeholder="#000000"
                      spellcheck="false"
                      aria-label="Minty Online Ordering Color hex"
                      @input="onHexInput($event.target.value, (hex) => (branch.moo_color = hex))"
                      @blur="$event.target.value = branch.moo_color"
                    />
                  </div>
                </div>
              </div>

              <!-- KSK105 — Kiosk Card Background -->
              <div class="field-row">
                <div class="field-label">
                  Kiosk Card Background
                  <div class="text-xs text-secondary">
                    The whole kiosk background (page, header, bars, cards). Shown as a light
                    6% tint so text stays easy to read; cards stand out by their shadow.
                  </div>
                </div>
                <div class="field-value">
                  <div class="d-flex align-items-center flex-wrap gap-3">
                    <!-- disable-alpha: the picker would emit rgba(), which the API refuses. -->
                    <color-input
                      v-model="kioskCardColorInput"
                      disable-alpha
                      position="right bottom"
                    />
                    <!-- KSK109 -->
                    <input
                      :value="kioskCardColorInput"
                      type="text"
                      class="hex-input"
                      maxlength="7"
                      placeholder="#ffffff"
                      spellcheck="false"
                      aria-label="Kiosk Card Background hex"
                      @input="onHexInput($event.target.value, (hex) => (kioskCardColorInput = hex))"
                      @blur="$event.target.value = kioskCardColorInput"
                    />
                    <span class="kiosk-card-preview" :style="{ background: kioskCardPreview }">
                      Preview
                    </span>
                    <button
                      v-if="branch.kiosk_card_color"
                      type="button"
                      class="btn btn-link btn-sm mb-0 p-0"
                      @click="branch.kiosk_card_color = ''"
                    >
                      Reset to white
                    </button>
                  </div>
                </div>
              </div>

              <!-- Operating Hours -->
              <div class="field-row field-row--block">
                <div class="field-label">Operating Hours</div>
                <div class="field-value w-100">
                  <div class="table-responsive">
                    <table class="table align-items-center mb-0 op-hours-table">
                      <thead>
                        <tr>
                          <th
                            class="text-start font-weight-bolder"
                            style="width: 120px"
                          >
                            Day
                          </th>
                          <th
                            class="text-start font-weight-bolder"
                            style="width: 200px"
                          >
                            Period Type
                          </th>
                          <th class="text-start font-weight-bolder">Period</th>
                        </tr>
                      </thead>
                      <tbody v-if="branch?.operation_days?.length">
                        <tr
                          v-for="(value, key) in branch.operation_days"
                          :key="key"
                        >
                          <td class="text-start align-middle">
                            {{ value.day_name }}
                          </td>
                          <td class="text-start">
                            <Multiselect
                              v-model="value.period_type"
                              :options="periodType"
                              placeholder="Select period"
                              :canClear="false"
                            />
                          </td>
                          <td
                            class="text-start ps-3"
                            v-if="value.period_type == 1"
                          >
                            <div
                              v-for="(item, index) in value.operation_hours"
                              :key="index"
                              class="d-flex align-items-center mb-1"
                            >
                              {{
                                item.start_time_format +
                                " - " +
                                item.end_time_format
                              }}
                              <i
                                class="material-icons opacity-10 ms-2 text-danger cursor-pointer"
                                @click="removePeriod(key, index)"
                                >remove</i
                              >
                            </div>
                            <div
                              class="cursor-pointer"
                              @click="addPeriod(value.day_of_week)"
                            >
                              <i class="material-icons opacity-10 text-info"
                                >add</i
                              >
                            </div>
                          </td>
                          <td class="text-start ps-3" v-else>N/A</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- GrabFood: saving the Store ID only sets the store up (menu sync). Grab orders
                   are turned ON/OFF apart, on Settings > GrabFood > Store. Empty = not on Grab. -->
              <div class="field-row">
                <div class="field-label">GrabFood Store ID</div>
                <div class="field-value">
                  <div class="d-flex align-items-center gap-2">
                    <material-input
                      v-model="branch.grabfood_store_id"
                      name="grab_store_id"
                      class="w-input-sm"
                      placeholder="Enter GrabFood Store ID"
                    />
                    <button
                      @click="syncGrabMenu()"
                      class="btn btn-sm btn-background mb-0"
                      :disabled="
                        !branch.grabfood_store_id ||
                        isGrabStorePendingVerification ||
                        hasZeroPricedMainItem ||
                        hasOverlappingMenusetHours
                      "
                      style="white-space: nowrap;"
                    >
                      <i class="fas fa-sync-alt me-1" :class="{ 'fa-spin': isSyncing }" style="font-size: 1rem;"></i>
                      {{ isSyncing ? 'Syncing...' : 'Sync Menu' }}
                    </button>
                    <div v-if="branch.grabfood_last_sync_status" class="ms-3" style="font-size: 13px; line-height: 1.6;">
                      <div><span class="text-muted">Last update sync at:</span> {{ branch.grabfood_last_sync_at || 'N/A' }}</div>
                      <div><span class="text-muted">Status:</span>
                        <span :class="branch.grabfood_last_sync_status === 'SUCCESS' ? 'text-success' : 'text-danger'" class="fw-bold">
                          {{ branch.grabfood_last_sync_status }}
                        </span>
                      </div>
                      <div v-if="branch.grabfood_last_sync_error"><span class="text-muted">Errors:</span>
                        <span class="text-danger">{{ branch.grabfood_last_sync_error }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="isGrabStoreSaved" class="mt-1" style="font-size: 13px;">
                    <span class="text-muted">Grab orders:</span>
                    <span
                      class="fw-bold"
                      :class="branch.grabfood_integration == 1 ? 'text-success' : 'text-danger'"
                    >
                      {{ branch.grabfood_integration == 1 ? "ON" : "OFF" }}
                    </span>
                    <span v-if="branch.grabfood_integration != 1 && branch.grabfood_paused_on_grab" class="text-muted">
                      (paused on Grab)</span
                    >
                    -
                    <router-link to="/grabfood-general-setting" class="text-primary">
                      turn ON/OFF in GrabFood settings
                    </router-link>
                  </div>
                  <div class="text-warning" v-if="grabLinkMessage">
                    {{ grabLinkMessage }}
                  </div>
                  <div class="is-invalid" v-if="hasZeroPricedMainItem">
                    Sync Menu is disabled: {{ zeroPricedItems.length }} main item(s) are priced at $0
                    at the selected GrabFood Price level. Please set a price for
                    {{ zeroPricedItemNames }}.
                  </div>
                  <div class="is-invalid" v-if="hasOverlappingMenusetHours">
                    Sync Menu is disabled: {{ overlappingMenusetHours }}
                    Each menu set becomes its own GrabFood menu section, and
                    sections cannot be open at the same time. Set their hours
                    apart under Menu Set &gt; Grab Menu Sections.
                  </div>
                </div>
              </div>

              <!-- Menuset -->
              <div class="field-row">
                <div class="field-label">
                  Menuset <span class="text-danger">*</span>
                </div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.menuset_ids"
                    mode="tags"
                    :close-on-select="true"
                    :searchable="true"
                    :options="menuset"
                    placeholder="Select menuset"
                    :canClear="false"
                    class="menuset-select"
                  />
                  <span class="is-invalid" v-if="fieldRequired.isMenusetRequire"
                    >The field is required.</span
                  >
                </div>
              </div>

              <!-- Price List -->
              <div class="field-row">
                <div class="field-label">
                  Price List <span class="text-danger">*</span>
                </div>
                <div class="field-value">
                  <!-- Header row (desktop only) -->
                  <div class="price-header d-none d-md-flex mb-1">
                    <div style="width: 110px"></div>
                    <div class="label-form" style="min-width: 200px">
                      Default Price
                    </div>
                    <div class="label-form" style="min-width: 200px">
                      Member Price
                    </div>
                    <div v-if="priceSchedulesSupported" class="label-form" style="min-width: 200px">
                      Scheduled Price
                    </div>
                  </div>
                  <!-- Main Items -->
                  <div class="price-row">
                    <div class="price-row__label label-form">Main Items</div>
                    <div class="price-row__inputs">
                      <div class="price-input-group">
                        <div class="d-block d-md-none price-sublabel">
                          Default Price
                        </div>
                        <Multiselect
                          v-model="branch.main_item_default_price"
                          :options="prices"
                          placeholder="Select price"
                          :canClear="false"
                          class="price-select"
                        />
                      </div>
                      <div class="price-input-group">
                        <div class="d-block d-md-none price-sublabel">
                          Member Price
                        </div>
                        <Multiselect
                          v-model="branch.main_item_member_price"
                          :options="prices"
                          placeholder="Select price"
                          :canClear="false"
                          class="price-select"
                        />
                      </div>
                      <!-- Special Scheduled Price: everything (switch + schedules) is set and saved
                           in ModalPriceSchedules. -->
                      <div v-if="priceSchedulesSupported" class="price-input-group">
                        <div class="d-block d-md-none price-sublabel">
                          Scheduled Price
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm capitalize btn-background mb-0 price-schedule-btn"
                          :disabled="!branch.id"
                          :title="branch.id ? 'Set Special Scheduled Price' : 'Save the sales channel first'"
                          @click="$refs.priceSchedules.open(branch.price_schedules, branch.price_schedules_enabled)"
                        >
                          <i class="material-icons price-schedule-btn__icon">schedule</i>
                          Schedule
                          <span
                            class="price-schedule-btn__state"
                            :class="{ 'price-schedule-btn__state--on': branch.price_schedules_enabled == 1 }"
                            >{{ priceScheduleSummary }}</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Modifiers -->
                  <div class="price-row mt-2">
                    <div class="price-row__label label-form">Modifiers</div>
                    <div class="price-row__inputs">
                      <div class="price-input-group">
                        <div class="d-block d-md-none price-sublabel">
                          Default Price
                        </div>
                        <Multiselect
                          v-model="branch.modifier_default_price"
                          :options="prices"
                          placeholder="Select price"
                          :canClear="false"
                          class="price-select"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- GrabFood Price -->
                  <div class="price-row mt-2" v-if="hasGrabStoreId">
                    <div class="price-row__label label-form">GrabFood Price</div>
                    <div class="price-row__inputs">
                      <div class="price-input-group">
                        <div class="d-block d-md-none price-sublabel">
                          GrabFood Price
                        </div>
                        <Multiselect
                          v-model="branch.grabfood_main_price"
                          :options="prices"
                          placeholder="Select price"
                          :canClear="false"
                          class="price-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ══════════════════════════════
                   ORDERING MODE
              ══════════════════════════════ -->
              <div class="section-heading"><h4>Ordering Mode</h4></div>

              <div class="field-row">
                <div class="field-label">
                  Enable Pickup/Delivery selection on Cart Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_pickup_delivery_option_moo"
                      name="show_pickup_delivery_option_moo"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_pickup_delivery_option_moo"
                      name="show_pickup_delivery_option_moo"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- M995: a channel may offer only Pickup or only Delivery (e.g. the Lalamove one). -->
              <div class="field-row" v-if="branch.show_pickup_delivery_option_moo == 1">
                <div class="field-label">Order types offered</div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      id="pickup_delivery_mode_pickup"
                      v-model="branch.pickup_delivery_mode"
                      name="pickup_delivery_mode"
                      >Pickup</MaterialRadio
                    >
                    <MaterialRadio
                      :value="2"
                      id="pickup_delivery_mode_delivery"
                      v-model="branch.pickup_delivery_mode"
                      name="pickup_delivery_mode"
                      >Delivery</MaterialRadio
                    >
                    <MaterialRadio
                      :value="3"
                      id="pickup_delivery_mode_both"
                      v-model="branch.pickup_delivery_mode"
                      name="pickup_delivery_mode"
                      >Both</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row" v-if="channelOffersPickup">
                <div class="field-label">
                  Pickup Notes
                  <span class="fs-12"
                    >(to show on MOO cart when pickup selected)</span
                  >
                </div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="pickup_notes"
                    v-model="branch.pickup_notes"
                    name="pickup_notes"
                    class="branch-address"
                  />
                  <div class="text-danger fs-14 mt-1">(max 100 characters)</div>
                </div>
              </div>

              <template v-if="channelOffersDelivery">
              <div class="field-row">
                <div class="field-label">
                  Delivery Notes
                  <span class="fs-12"
                    >(to show on MOO cart when delivery selected)</span
                  >
                </div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="delivery_notes"
                    v-model="branch.delivery_notes"
                    name="delivery_notes"
                    class="branch-address"
                  />
                  <div class="text-danger fs-14 mt-1">(max 100 characters)</div>
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Delivery Fee Item Number:</div>
                <div class="field-value">
                  <material-input
                    id="delivery_fee_item_number"
                    v-model="branch.delivery_fee_item_number"
                    name="delivery_fee_item_number"
                    class="w-input-sm"
                    placeholder="0"
                  />
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">
                  Delivery Fee set to 0 if bill total greater than:
                </div>
                <div class="field-value">
                  <material-input
                    type="number"
                    id="minimum_total_for_free_delivery_fee"
                    v-model="branch.minimum_total_for_free_delivery_fee"
                    name="minimum_total_for_free_delivery_fee"
                    class="w-input-sm"
                    placeholder="100"
                  />
                </div>
              </div>
              </template>

              <!-- M986 follow-up: when MOO customers can have their order delivered, and the
                   smallest order that may be delivered. -->
              <template v-if="branch.show_pickup_delivery_option_moo == 1">
                <div class="field-row" v-if="channelOffersDelivery">
                  <div class="field-label">
                    Minimum order for delivery
                    <span class="fs-12">(0 = no minimum)</span>
                  </div>
                  <div class="field-value">
                    <material-input
                      type="number"
                      id="delivery_minimum_order"
                      v-model="branch.delivery_minimum_order"
                      name="delivery_minimum_order"
                      class="w-input-sm"
                      placeholder="0"
                    />
                  </div>
                </div>

                <div class="field-row" v-if="channelOffersPickup">
                  <div class="field-label">
                    Minimum order for pickup
                    <span class="fs-12">(0 = no minimum)</span>
                  </div>
                  <div class="field-value">
                    <material-input
                      type="number"
                      id="pickup_minimum_order"
                      v-model="branch.pickup_minimum_order"
                      name="pickup_minimum_order"
                      class="w-input-sm"
                      placeholder="0"
                    />
                  </div>
                </div>

                <template v-if="channelOffersDelivery">
                <div class="field-row">
                  <div class="field-label">Delivery days</div>
                  <div class="field-value">
                    <div class="d-flex flex-wrap gap-3">
                      <div
                        v-for="day in deliveryWeekDays"
                        :key="day.value"
                        class="d-flex align-items-center label-form"
                      >
                        <material-checkbox
                          :id="'delivery_day_' + day.value"
                          :modelValue="isDeliveryDay(day.value)"
                          :checked="isDeliveryDay(day.value)"
                          @update:modelValue="toggleDeliveryDay(day.value, $event)"
                          :name="'delivery_day_' + day.value"
                          class="align-items-center px-2"
                        ></material-checkbox>
                        {{ day.label }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="field-row">
                  <div class="field-label">Delivery slots</div>
                  <div class="field-value">
                    <template v-if="branch.id">
                      <a href="javascript:void(0)" class="text-decoration-underline" @click="$refs.deliverySlots.open()">Edit delivery slots</a>
                      <div class="fs-14 mt-1">Each slot has its own cut-off time, display text and quotas.</div>
                    </template>
                    <div v-else class="fs-14">Save the sales channel first, then set its delivery slots.</div>
                  </div>
                </div>

                <div class="field-row">
                  <div class="field-label">
                    Cut-off time offset
                    <span class="fs-12">(hours)</span>
                  </div>
                  <div class="field-value">
                    <material-input
                      type="number"
                      id="delivery_cutoff_offset_hours"
                      v-model="branch.delivery_cutoff_offset_hours"
                      name="delivery_cutoff_offset_hours"
                      class="w-input-sm"
                      placeholder="0"
                    />
                    <div class="fs-14 mt-1">Moves every slot's cut-off this many hours earlier (e.g. 24 = order by the day before).</div>
                  </div>
                </div>

                <div class="field-row">
                  <div class="field-label">
                    Advance order
                    <span class="fs-12">(how many days)</span>
                  </div>
                  <div class="field-value">
                    <material-input
                      type="number"
                      id="delivery_advance_days"
                      v-model="branch.delivery_advance_days"
                      name="delivery_advance_days"
                      class="w-input-sm"
                      placeholder="7"
                    />
                  </div>
                </div>

                <div class="field-row">
                  <div class="field-label">Delivery fee</div>
                  <div class="field-value">
                    <div class="d-flex flex-wrap align-items-center gap-3">
                      <MaterialRadio
                        :value="1"
                        id="delivery_fee_mode_fixed"
                        v-model="branch.delivery_fee_mode"
                        name="delivery_fee_mode"
                        >Fixed fee</MaterialRadio
                      >
                      <MaterialRadio
                        :value="2"
                        id="delivery_fee_mode_distance"
                        v-model="branch.delivery_fee_mode"
                        name="delivery_fee_mode"
                        >By distance</MaterialRadio
                      >
                      <a
                        v-if="branch.id && branch.delivery_fee_mode == 2"
                        href="javascript:void(0)"
                        class="text-decoration-underline"
                        @click="$refs.deliveryChargeTiers.open()"
                        >Edit charges by distance</a
                      >
                    </div>
                    <div class="fs-14 mt-1">
                      Fixed fee charges the Delivery Fee item price. By distance charges by the
                      straight-line distance to the customer's postal code.
                    </div>
                  </div>
                </div>
                </template>
              </template>

              <!-- M986: book a Lalamove driver once a MOO Delivery order is paid. The
                   pickup point is this store's postal code (Store Address above). -->
              <template v-if="branch.id && branch.show_pickup_delivery_option_moo == 1 && channelOffersDelivery">
                <div class="field-row">
                  <div class="field-label">
                    Book Lalamove driver for paid delivery orders
                  </div>
                  <div class="field-value">
                    <div class="d-flex flex-wrap gap-3">
                      <MaterialRadio
                        id="lalamove_enabled_yes"
                        :value="1"
                        class="ps-0"
                        v-model="lalamove.is_enabled"
                        name="lalamove_enabled"
                        >Yes</MaterialRadio
                      >
                      <MaterialRadio
                        id="lalamove_enabled_no"
                        :value="0"
                        v-model="lalamove.is_enabled"
                        name="lalamove_enabled"
                        >No</MaterialRadio
                      >
                    </div>
                  </div>
                </div>

                <template v-if="lalamove.is_enabled == 1">
                  <div class="field-row">
                    <div class="field-label">Lalamove Vehicle</div>
                    <div class="field-value">
                      <Multiselect
                        v-model="lalamove.service_type"
                        :options="lalamoveServiceTypes"
                        :canClear="false"
                        class="menuset-select"
                      />
                    </div>
                  </div>

                  <template v-if="lalamove.service_type !== 'OWN'">
                  <div class="field-row">
                    <div class="field-label">
                      Pickup Contact Phone
                      <span class="fs-12">(given to the driver, +65)</span>
                    </div>
                    <div class="field-value">
                      <material-input
                        id="lalamove_sender_phone"
                        v-model="lalamove.sender_phone"
                        name="lalamove_sender_phone"
                        class="w-input-sm"
                        maxLength="8"
                        placeholder="61234567"
                      />
                    </div>
                  </div>

                  <div class="field-row">
                    <div class="field-label">Lalamove API Key</div>
                    <div class="field-value">
                      <material-input
                        id="lalamove_api_key"
                        v-model="lalamove.api_key"
                        name="lalamove_api_key"
                        class="branch-address"
                        placeholder="pk_test_... / pk_prod_..."
                      />
                    </div>
                  </div>

                  <div class="field-row">
                    <div class="field-label">Lalamove API Secret</div>
                    <div class="field-value">
                      <material-input
                        id="lalamove_api_secret"
                        type="password"
                        v-model="lalamove.api_secret"
                        name="lalamove_api_secret"
                        class="branch-address"
                        :placeholder="lalamove.has_api_secret ? 'Saved - leave blank to keep' : 'sk_test_... / sk_prod_...'"
                      />
                    </div>
                  </div>

                  <!-- M1004: extra charge for a CBD address, by postal sector. Lalamove only -
                       own delivery never charges it. -->
                  <div class="field-row">
                    <div class="field-label">CBD surcharge</div>
                    <div class="field-value">
                      <div class="d-flex flex-wrap gap-3">
                        <MaterialRadio
                          id="cbd_surcharge_enabled_yes"
                          :value="1"
                          class="ps-0"
                          v-model="branch.cbd_surcharge_enabled"
                          name="cbd_surcharge_enabled"
                          >Yes</MaterialRadio
                        >
                        <MaterialRadio
                          id="cbd_surcharge_enabled_no"
                          :value="0"
                          v-model="branch.cbd_surcharge_enabled"
                          name="cbd_surcharge_enabled"
                          >No</MaterialRadio
                        >
                      </div>
                      <div class="fs-14 mt-1">
                        Added to the delivery fee when the delivery postal code is in the CBD,
                        even when the delivery fee is free.
                      </div>
                    </div>
                  </div>

                  <template v-if="branch.cbd_surcharge_enabled == 1">
                    <div class="field-row">
                      <div class="field-label">CBD surcharge amount</div>
                      <div class="field-value">
                        <material-input
                          type="number"
                          id="cbd_surcharge_amount"
                          v-model="branch.cbd_surcharge_amount"
                          name="cbd_surcharge_amount"
                          class="w-input-sm"
                          placeholder="3"
                        />
                      </div>
                    </div>

                    <div class="field-row">
                      <div class="field-label">
                        CBD postal sectors
                        <span class="fs-12">(first 2 digits of the postal code)</span>
                      </div>
                      <div class="field-value">
                        <material-input
                          id="cbd_postal_prefixes"
                          v-model="branch.cbd_postal_prefixes"
                          name="cbd_postal_prefixes"
                          class="branch-address"
                          placeholder="01,02,03,04,05,06,07,08"
                        />
                      </div>
                    </div>
                  </template>
                  </template>
                </template>
              </template>

              <div class="field-row">
                <div class="field-label">Branch Waiting Time</div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.waiting_time"
                    :options="waitingTime"
                    placeholder="Select Waiting Time"
                    :canClear="false"
                    class="menuset-select"
                  />
                </div>
              </div>

              <!-- Theme -->
              <div class="field-row">
                <div class="field-label">
                  Theme <span class="text-danger">*</span>
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.theme"
                      name="theme"
                      >Theme 1</MaterialRadio
                    >
                    <MaterialRadio
                      :value="2"
                      v-model="branch.theme"
                      name="theme"
                      >Theme 2</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- SF283: Advocado outlet this sales channel's QR orders are booked against.
                   Theme 2 channels only (their QR opens the Advocado ordering site), and only
                   where Advocado answers with outlets or a saved one exists. -->
              <div
                class="field-row"
                v-if="isAdvocadoTheme && (advocadoOutletOptions.length || branch.advocado_outlet_id)"
              >
                <div class="field-label">
                  Advocado outlet
                  <span class="text-danger" v-if="advocadoOutletRequired">*</span>
                  <div class="text-xs text-secondary">
                    Where this channel's QR earn / redeem shows in Advocado
                  </div>
                </div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.advocado_outlet_id"
                    :searchable="true"
                    :options="advocadoOutletOptions"
                    placeholder="Select Advocado outlet"
                  />
                  <span class="is-invalid" v-if="fieldRequired.isAdvocadoOutletRequire"
                    >The field is required.</span
                  >
                </div>
              </div>

              <!-- SH001 — Theme for Salon -->
              <div class="field-row">
                <div class="field-label">Theme for Salon</div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.salon_theme"
                      name="salon_theme"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.salon_theme"
                      name="salon_theme"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- SH008 — Salon Booking: turnaround, and who works this channel -->
              <template v-if="branch.salon_theme == 1">
                <div class="subsection-heading"><h6>Salon Booking</h6></div>

                <div class="field-row field-row--indented">
                  <div class="field-label">
                    Gap Between Appointments
                    <span class="fs-12"
                      >(minutes to leave between two bookings; a stylist can
                      override it)</span
                    >
                  </div>
                  <div class="field-value">
                    <material-input
                      v-model="branch.appointment_gap_min"
                      type="number"
                      placeholder="0"
                    />
                  </div>
                </div>

                <!-- SH026 — which question the booking flow asks first -->
                <div class="field-row field-row--indented">
                  <div class="field-label">
                    Booking Flow
                    <span class="fs-12"
                      >(what the customer picks first after choosing a service)</span
                    >
                  </div>
                  <div class="field-value">
                    <div class="d-flex flex-column">
                      <MaterialRadio
                        :value="1"
                        class="ps-0"
                        v-model="branch.salon_booking_flow"
                        name="salon_booking_flow"
                        >Pick a date first</MaterialRadio
                      >
                      <MaterialRadio
                        :value="2"
                        class="ps-0"
                        v-model="branch.salon_booking_flow"
                        name="salon_booking_flow"
                        >Choose staff first</MaterialRadio
                      >
                      <MaterialRadio
                        :value="3"
                        class="ps-0"
                        v-model="branch.salon_booking_flow"
                        name="salon_booking_flow"
                        >Let the customer switch between the two</MaterialRadio
                      >
                    </div>
                  </div>
                </div>

                <!-- SH031 — whether appointments open a bill on POS at all -->
                <div class="field-row field-row--indented">
                  <div class="field-label">
                    Send Orders Into POS
                    <span class="fs-12"
                      >(open a pay-later bill on POS for every appointment, booked
                      online or typed into the calendar)</span
                    >
                  </div>
                  <div class="field-value">
                    <div class="d-flex flex-wrap gap-3">
                      <MaterialRadio
                        :value="1"
                        class="ps-0"
                        v-model="branch.salon_send_orders_to_pos"
                        name="salon_send_orders_to_pos"
                        >Yes</MaterialRadio
                      >
                      <MaterialRadio
                        :value="0"
                        v-model="branch.salon_send_orders_to_pos"
                        name="salon_send_orders_to_pos"
                        >No</MaterialRadio
                      >
                    </div>
                  </div>
                </div>

                <!-- SH032 — whether the booking flow quotes a price at all -->
                <div class="field-row field-row--indented">
                  <div class="field-label">
                    Show Service Fees
                    <span class="fs-12"
                      >(print the price of each service while the customer is
                      booking — on the service picker and the review screen)</span
                    >
                  </div>
                  <div class="field-value">
                    <div class="d-flex flex-wrap gap-3">
                      <MaterialRadio
                        :value="1"
                        class="ps-0"
                        v-model="branch.salon_show_service_price"
                        name="salon_show_service_price"
                        >Yes</MaterialRadio
                      >
                      <MaterialRadio
                        :value="0"
                        v-model="branch.salon_show_service_price"
                        name="salon_show_service_price"
                        >No</MaterialRadio
                      >
                    </div>
                  </div>
                </div>

                <div class="field-row field-row--indented" v-if="isExistingBranch">
                  <div class="field-label">
                    Service Staff
                    <span class="fs-12"
                      >(who customers can book at this channel; adding and removing
                      saves straight away, not on Save)</span
                    >
                  </div>
                  <div class="field-value">
                    <div class="d-flex flex-wrap gap-2 align-items-center mb-2">
                      <input
                        v-model="assignedKeyword"
                        type="search"
                        class="form-control form-control-sm service-staff-search"
                        placeholder="Search assigned staff"
                        @input="onAssignedSearch"
                      />
                      <span class="fs-12 text-muted"
                        >{{ assignedTotal }} assigned</span
                      >
                      <button
                        type="button"
                        class="btn btn-sm btn-background mb-0 ms-auto"
                        @click="openStaffPicker"
                      >
                        Add staff
                      </button>
                    </div>

                    <div v-if="assignedStaff.length" class="service-staff-list">
                      <div
                        v-for="staff in assignedStaff"
                        :key="staff.id"
                        class="service-staff-row"
                      >
                        <img
                          v-if="staff.image"
                          :src="staff.image"
                          class="service-staff-avatar"
                          :alt="staff.name"
                        />
                        <span
                          v-else
                          class="service-staff-avatar service-staff-avatar--blank"
                        >
                          {{ (staff.name || "?").charAt(0).toUpperCase() }}
                        </span>
                        <div class="service-staff-body">
                          <div class="service-staff-name">{{ staff.name }}</div>
                          <div class="service-staff-title">
                            {{ staff.job_title || "—" }}
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger py-1 px-2 mb-0"
                          @click="removeServiceStaff(staff)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                    <p v-else class="fs-12 mb-2">
                      {{
                        assignedKeyword
                          ? "No assigned staff match that search."
                          : "No staff assigned yet — customers will see no one to book with on this channel."
                      }}
                    </p>

                    <div
                      v-if="assignedLastPage > 1"
                      class="d-flex gap-2 align-items-center mt-2"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary staff-picker-page mb-0"
                        :disabled="assignedPage <= 1"
                        @click="goAssignedPage(assignedPage - 1)"
                      >
                        ‹
                      </button>
                      <span class="fs-12"
                        >Page {{ assignedPage }} of {{ assignedLastPage }}</span
                      >
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary staff-picker-page mb-0"
                        :disabled="assignedPage >= assignedLastPage"
                        @click="goAssignedPage(assignedPage + 1)"
                      >
                        ›
                      </button>
                    </div>
                  </div>
                </div>
              </template>

              <!-- ══════════════════════════════
                   BEHAVIORS
              ══════════════════════════════ -->
              <div class="section-heading"><h4>Behaviors</h4></div>

              <!-- QR Code -->
              <div class="subsection-heading"><h6>QR Code</h6></div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Page to Open After Scanning QR
                  <span class="fs-12"
                    >(applies to already-printed QR codes too)</span
                  >
                </div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.moo_qr_redirect_page"
                    :options="qr_redirect_pages"
                    :canClear="false"
                    class="menuset-select"
                  />
                </div>
              </div>

              <!-- SF263 -->
              <div class="field-row field-row--indented">
                <div class="field-label">
                  Item Popup After Scanning QR
                  <span class="fs-12"
                    >(up to 3 dishes, sliding on a popup shown once per visit on
                    the ordering page)</span
                  >
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.promo_popup_enabled"
                      name="promo_popup_enabled"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.promo_popup_enabled"
                      name="promo_popup_enabled"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div
                class="field-row field-row--indented2"
                v-if="branch.promo_popup_enabled == 1"
              >
                <div class="field-label">- Items on the popup</div>
                <div class="field-value">
                  <!-- SF294: up to 3 items, slid in the order picked. Empty = latest items. -->
                  <Multiselect
                    v-model="branch.promo_popup_item_ids"
                    mode="tags"
                    :max="3"
                    :options="promoPopupItems"
                    :searchable="true"
                    :canClear="false"
                    :filterResults="false"
                    :close-on-select="true"
                    placeholder="Latest items added"
                    class="menuset-select"
                    @open="getPromoPopupItems()"
                    @search-change="getPromoPopupItems"
                  />
                  <div class="fs-12" v-if="promoPopupItemWarning">
                    {{ promoPopupItemWarning }}
                  </div>
                </div>
              </div>

              <!-- SF295 -->
              <div class="field-row field-row--indented">
                <div class="field-label">
                  Menu Banner
                  <span class="fs-12"
                    >(one tall rectangle beside two squares on the ordering
                    page, picked from this channel's upsell items; nothing
                    picked hides the banner)</span
                  >
                </div>
                <div class="field-value"></div>
              </div>

              <div class="field-row field-row--indented2">
                <div class="field-label">- Rectangle (1 dish)</div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.menu_banner_rect_item_id"
                    :options="menuBannerRectOptions"
                    :searchable="true"
                    :canClear="true"
                    :filterResults="false"
                    placeholder="No dish"
                    class="menuset-select"
                    @open="getMenuBannerItems()"
                    @search-change="getMenuBannerItems"
                  />
                  <div class="menu-banner-images">
                    <div
                      class="menu-banner-image"
                      v-for="bannerSlot in menuBannerRectSlots"
                      :key="bannerSlot.column"
                    >
                      <div
                        class="menu-banner-image__preview menu-banner-image__preview--rect"
                      >
                        <img
                          v-if="menuBannerImagePreview(bannerSlot.column)"
                          :src="menuBannerImagePreview(bannerSlot.column)"
                          :alt="bannerSlot.label"
                        />
                        <span v-else class="fs-12">Dish image</span>
                        <i
                          v-if="menuBannerImagePreview(bannerSlot.column)"
                          class="fa fa-times menu-banner-image__remove"
                          aria-hidden="true"
                          @click="clearMenuBannerImage(bannerSlot.column)"
                        ></i>
                      </div>
                      <input
                        :id="'menu-banner-file-' + bannerSlot.column"
                        type="file"
                        accept="image/png,image/jpeg,image/gif,image/webp"
                        style="display: none"
                        @change="onMenuBannerImageChange(bannerSlot.column, $event)"
                      />
                      <material-button
                        class="btn btn-sm capitalize btn-background mb-0"
                        @click="pickMenuBannerImage(bannerSlot.column)"
                        >Upload Image</material-button
                      >
                      <div class="upload-size-hint">{{ bannerSlot.hint }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented2">
                <div class="field-label">- Squares (up to 2 dishes, top to bottom)</div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.menu_banner_square_item_ids"
                    mode="tags"
                    :max="2"
                    :options="menuBannerSquareOptions"
                    :searchable="true"
                    :canClear="false"
                    :filterResults="false"
                    :close-on-select="true"
                    placeholder="No dish"
                    class="menuset-select"
                    @open="getMenuBannerItems()"
                    @search-change="getMenuBannerItems"
                  />
                  <div class="menu-banner-images">
                    <div
                      class="menu-banner-image"
                      v-for="bannerSlot in menuBannerSquareSlots"
                      :key="bannerSlot.column"
                    >
                      <div class="fs-12">{{ bannerSlot.label }}</div>
                      <div
                        class="menu-banner-image__preview menu-banner-image__preview--square"
                      >
                        <img
                          v-if="menuBannerImagePreview(bannerSlot.column)"
                          :src="menuBannerImagePreview(bannerSlot.column)"
                          :alt="bannerSlot.label"
                        />
                        <span v-else class="fs-12">Dish image</span>
                        <i
                          v-if="menuBannerImagePreview(bannerSlot.column)"
                          class="fa fa-times menu-banner-image__remove"
                          aria-hidden="true"
                          @click="clearMenuBannerImage(bannerSlot.column)"
                        ></i>
                      </div>
                      <input
                        :id="'menu-banner-file-' + bannerSlot.column"
                        type="file"
                        accept="image/png,image/jpeg,image/gif,image/webp"
                        style="display: none"
                        @change="onMenuBannerImageChange(bannerSlot.column, $event)"
                      />
                      <material-button
                        class="btn btn-sm capitalize btn-background mb-0"
                        @click="pickMenuBannerImage(bannerSlot.column)"
                        >Upload Image</material-button
                      >
                      <div class="upload-size-hint">{{ bannerSlot.hint }}</div>
                    </div>
                  </div>
                  <div class="fs-12 text-danger" v-if="menuBannerImageError">
                    {{ menuBannerImageError }}
                  </div>
                  <div class="fs-12" v-if="menuBannerItemWarning">
                    {{ menuBannerItemWarning }}
                  </div>
                </div>
              </div>

              <!-- Login -->
              <div class="subsection-heading"><h6>Login</h6></div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Page to Open After Login
                  <span class="fs-12"
                    >(also applies to a member who just registered)</span
                  >
                </div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.moo_after_login_page"
                    :options="after_login_pages"
                    :canClear="false"
                    class="menuset-select"
                  />
                </div>
              </div>

              <!-- SF284 -->
              <div class="field-row field-row--indented">
                <div class="field-label">
                  Member Login on Queue QR
                  <span class="fs-12"
                    >(No hides the phone number and Login / Register, leaving
                    Continue as Guest)</span
                  >
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.queue_qr_member_login_enabled"
                      name="queue_qr_member_login_enabled"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.queue_qr_member_login_enabled"
                      name="queue_qr_member_login_enabled"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- SF285 -->
              <div class="field-row field-row--indented">
                <div class="field-label">
                  Member Login on Table QR
                  <span class="fs-12"
                    >(No hides the phone number and Login / Register, leaving
                    Continue as Guest)</span
                  >
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.table_qr_member_login_enabled"
                      name="table_qr_member_login_enabled"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.table_qr_member_login_enabled"
                      name="table_qr_member_login_enabled"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- M1051 -->
              <div class="field-row field-row--indented">
                <div class="field-label">
                  Hide Login &amp; Rewards on Online Ordering
                  <span class="fs-12"
                    >(Yes hides the Rewards and Login menu icons, leaving
                    guest ordering only)</span
                  >
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.hide_member_login_moo"
                      name="hide_member_login_moo"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.hide_member_login_moo"
                      name="hide_member_login_moo"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- Landing Page -->
              <div class="subsection-heading"><h6>Landing Page</h6></div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Landing page on Online Ordering page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_landing_page_on_ordering_online"
                      name="show_landing_page_on_ordering_online"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_landing_page_on_ordering_online"
                      name="show_landing_page_on_ordering_online"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Login Required on Online Ordering Login Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.login_required"
                      name="login_required"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.login_required"
                      name="login_required"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Number of Pax Selection on Online Ordering Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_number_of_pax"
                      name="show_number_of_pax"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_number_of_pax"
                      name="show_number_of_pax"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- Ordering Page -->
              <div class="subsection-heading"><h6>Ordering Page</h6></div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Unavailable Item on Online Ordering page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      name="show_unavailable_items_on_ordering_online"
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_unavailable_items_on_ordering_online"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      name="show_unavailable_items_on_ordering_online"
                      :value="0"
                      v-model="branch.show_unavailable_items_on_ordering_online"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Enable Dine-in/Take Away Option on Online Ordering Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_dining_option_moo"
                      name="show_dining_option_moo"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_dining_option_moo"
                      name="show_dining_option_moo"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div
                class="field-row field-row--indented"
                v-if="branch.show_dining_option_moo == 1"
              >
                <div class="field-label">Dining Location</div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.dining_location_moo"
                    :options="dining_locations"
                    :canClear="false"
                    class="menuset-select"
                  />
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">Takeaway Indicator</div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.takeaway_indicator"
                    :options="takeaway_indicator_types"
                    :canClear="false"
                    class="menuset-select"
                  />
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Enable BCRS
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.enable_bcrs"
                      name="enable_bcrs"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.enable_bcrs"
                      name="enable_bcrs"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div
                class="field-row field-row--indented"
                v-if="branch.enable_bcrs == 1"
              >
                <div class="field-label">Each BCRS amount</div>
                <div class="field-value d-flex align-items-center">
                  <material-input
                    type="number"
                    v-model="branch.each_bcrs_amount"
                    id="each_bcrs_amount"
                    :name="each_bcrs_amount"
                    placeholder="Enter each BCRS amount"
                    class="w-input-sm"
                  />
                  <div class="ps-0 label-form d-flex align-items-end">$</div>
                </div>
              </div>

              <!-- Cart Page -->
              <div class="subsection-heading"><h6>Cart Page</h6></div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Special Instructions on Online Ordering page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="
                        branch.show_special_instructions_on_ordering_online
                      "
                      name="show_special_instructions_on_ordering_online"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="
                        branch.show_special_instructions_on_ordering_online
                      "
                      name="show_special_instructions_on_ordering_online"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div
                class="field-row field-row--indented2"
                v-if="branch.show_special_instructions_on_ordering_online == 1"
              >
                <div class="field-label">- Placeholder text</div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="special_instructions_placeholder"
                    v-model="branch.special_instructions_placeholder"
                    name="special_instructions_placeholder"
                    class="branch-address"
                    placeholder="Enter here"
                  />
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Pickup details on Online Ordering Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_pickup_details"
                      name="show_pickup_details"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_pickup_details"
                      name="show_pickup_details"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Buyer Contact Details on Online Ordering Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_contact_details"
                      name="show_contact_details"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_contact_details"
                      name="show_contact_details"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Delivery Contact on Online Ordering Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_delivery_contact_moo"
                      name="show_delivery_contact_moo"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_delivery_contact_moo"
                      name="show_delivery_contact_moo"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Enable open request on Online Ordering Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_open_request_option_moo"
                      name="show_open_request_option_moo"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_open_request_option_moo"
                      name="show_open_request_option_moo"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <template
                v-if="Number(branch.show_open_request_option_moo) === 1"
              >
                <div class="field-row field-row--indented2">
                  <div class="field-label">- Title</div>
                  <div class="field-value">
                    <material-input
                      maxLength="50"
                      id="open_request_title"
                      v-model="branch.open_request_title"
                      name="open_request_title"
                      class="branch-address"
                      placeholder="Are you songfa member?"
                    />
                  </div>
                </div>
                <div class="field-row field-row--indented2">
                  <div class="field-label">- Placeholder text</div>
                  <div class="field-value">
                    <material-input
                      maxLength="50"
                      id="open_request_placeholder_text"
                      v-model="branch.open_request_placeholder_text"
                      name="open_request_placeholder_text"
                      class="branch-address"
                      placeholder="Enter mobile number"
                    />
                  </div>
                </div>
              </template>

              <!-- Confirmation Page -->
              <div class="subsection-heading"><h6>Confirmation Page</h6></div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Pickup details on Order Confirmation Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_pickup_details_on_order_confirmation"
                      name="show_pickup_details_on_order_confirmation"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_pickup_details_on_order_confirmation"
                      name="show_pickup_details_on_order_confirmation"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div
                class="field-row field-row--indented"
                v-if="branch.show_pickup_details_on_order_confirmation == 1"
              >
                <div class="field-label">
                  Append modifiers to pickup details
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_remark_on_order_confirmation"
                      name="show_remark_on_order_confirmation"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_remark_on_order_confirmation"
                      name="show_remark_on_order_confirmation"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <div class="field-row field-row--indented">
                <div class="field-label">
                  Show Note on Order Confirmation Page
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      :value="1"
                      class="ps-0"
                      v-model="branch.show_note_on_order_confirmation"
                      name="show_note_on_order_confirmation"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      :value="0"
                      v-model="branch.show_note_on_order_confirmation"
                      name="show_note_on_order_confirmation"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- ══════════════════════════════
                   PAYMENT SETUP
              ══════════════════════════════ -->
              <div class="section-heading"><h4>Payment Setup</h4></div>

              <div class="field-row">
                <div class="field-label">Accept Payment on Moo</div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      value="1"
                      class="ps-0"
                      v-model="branch.accept_payment_on_moo"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      value="0"
                      v-model="branch.accept_payment_on_moo"
                      >No</MaterialRadio
                    >
                  </div>
                  <div
                    v-if="
                      branch.accept_payment_on_moo == 1 && !checkConnectStripe
                    "
                    style="color: red"
                    class="mt-1"
                  >
                    Physical Branch or Merchant must be connected to
                    {{ branch.payment_mode_moo == 2 ? "an AllInPay" : "a Stripe" }}
                    Account to accept payment on MOO.
                  </div>
                </div>
              </div>

              <div
                class="field-row"
                v-if="branch.accept_payment_on_moo == 1 && checkConnectStripe"
              >
                <div class="field-label">How Customer Make Payment</div>
                <div class="field-value">
                  <div class="d-flex flex-column gap-2">
                    <MaterialRadio
                      value="1"
                      class="ps-0"
                      v-model="branch.how_customer_make_payment"
                    >
                      Pay First (Pay at cart before submitting order)
                    </MaterialRadio>
                    <MaterialRadio
                      value="0"
                      v-model="branch.how_customer_make_payment"
                      style="padding-left: 0px !important"
                    >
                      Pay Later on Mobile (Submit order first from cart and then
                      pay on Order Status page)
                    </MaterialRadio>
                  </div>
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">MOO Payment Mode</div>
                <div class="field-value">
                  <Multiselect
                    v-model="branch.payment_mode_moo"
                    :options="payment_modes"
                    :canClear="false"
                    class="menuset-select"
                  />
                  <!-- Qlub pays the whole order once, before it is sent: Pay
                       First only, restaurant slug + key set on Payment. -->
                  <div
                    v-if="branch.payment_mode_moo == 5"
                    class="text-sm mt-1"
                    :class="branch.accept_payment_on_moo == 1 && branch.how_customer_make_payment == 0 ? 'text-danger' : 'text-muted'"
                  >
                    Qlub works with Pay First only. Set the Qlub restaurant slug and redirect key in Payment &gt; Qlub.
                  </div>
                </div>
              </div>

              <div class="field-row">
                <div class="field-label"></div>
                <div class="field-value">
                  <div class="d-flex flex-column gap-1">
                    <div class="d-flex align-items-center label-form">
                      <material-checkbox
                        @change="changeAllowPayNow(branch.allow_paynow)"
                        v-model="branch.allow_paynow"
                        :checked="branch.allow_paynow"
                        name="paynow"
                        class="align-items-center px-3"
                      ></material-checkbox>
                      PayNow
                    </div>
                    <div class="d-flex align-items-center label-form">
                      <material-checkbox
                        @change="changeAllowCreditCard(branch.allow_creditcard)"
                        v-model="branch.allow_creditcard"
                        :checked="branch.allow_creditcard"
                        name="creditcard"
                        class="align-items-center px-3"
                      ></material-checkbox>
                      Credit Card
                    </div>
                    <div class="d-flex align-items-center label-form">
                      <material-checkbox
                        @change="
                          changeAllowPaymentByMintyWallet(branch.allow_ewallet)
                        "
                        v-model="branch.allow_ewallet"
                        :checked="branch.allow_ewallet"
                        name="payment_by_minty_wallet"
                        class="align-items-center px-3"
                      ></material-checkbox>
                      Payment by Minty Wallet
                    </div>
                  </div>
                </div>
              </div>

              <!-- ══════════════════════════════
                   USEFUL LINKS
              ══════════════════════════════ -->
              <div class="section-heading"><h4>Useful Links</h4></div>

              <div class="field-row" v-if="branch.menuset_id">
                <div class="field-label">Stock Control Page</div>
                <div class="field-value">
                  <a
                    v-if="branch.stock_page_url"
                    :href="branchStockUrl(branch.stock_page_url)"
                    target="_blank"
                    class="text-break"
                    >{{ branch.stock_page_url }}</a
                  >
                  <span v-else
                    >Access link will be auto generated when branch is created
                    and its menu set is selected.</span
                  >
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Stock Control Page Passcode</div>
                <div class="field-value">
                  <material-input
                    maxLength="4"
                    id="stock_passcode"
                    v-model="branch.stock_passcode"
                    name="stock_passcode"
                    class="branch-address"
                    placeholder="Enter stock control page passcode"
                  />
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Order Management Page</div>
                <div class="field-value">
                  <a
                    v-if="branch.order_page_url"
                    :href="branchStockUrl(branch.order_page_url)"
                    target="_blank"
                    class="text-break"
                    >{{ branch.order_page_url }}</a
                  >
                  <span v-else
                    >Access link will be auto generated when branch is
                    created.</span
                  >
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">QR Generating</div>
                <div class="field-value">
                  <a
                    v-if="branch.qr_generating_url"
                    :href="branchStockUrl(branch.qr_generating_url)"
                    target="_blank"
                    class="text-break"
                    >{{ branch.qr_generating_url }}</a
                  >
                  <span v-else
                    >Access link will be auto generated when branch is
                    created.</span
                  >
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Queue QR Generating</div>
                <div class="field-value">
                  <a
                    v-if="branch.queue_qr_generating_url"
                    :href="branchStockUrl(branch.queue_qr_generating_url)"
                    target="_blank"
                    class="text-break"
                    >{{ branch.queue_qr_generating_url }}</a
                  >
                  <span v-else
                    >Access link will be auto generated when branch is
                    created.</span
                  >
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">MOO Order Page</div>
                <div class="field-value">
                  <a
                    v-if="branch.moo_order_url"
                    :href="branchStockUrl(branch.moo_order_url)"
                    target="_blank"
                    class="text-break"
                    >{{ branch.moo_order_url }}</a
                  >
                  <span v-else
                    >Access link will be auto generated when branch is
                    created.</span
                  >
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Dynamic QR Expiry Time</div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-2" style="max-width: 420px">
                    <material-input
                      type="number"
                      v-model="branch.qr_expiry_time"
                      id="qr_expiry_time"
                      name="qr_expiry_time"
                      placeholder="Enter expiry time"
                      style="flex: 1; min-width: 120px"
                    />
                    <Multiselect
                      v-model="branch.qr_expiry_time_unit"
                      :options="timeUnit"
                      placeholder="Select Time"
                      :canClear="false"
                      style="flex: 1; min-width: 140px"
                    />
                  </div>
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">Destination Link</div>
                <div class="field-value">
                  <material-input
                    maxLength="100"
                    id="destination_link"
                    v-model="branch.destination_link"
                    name="destination_link"
                    class="branch-address"
                    placeholder="Enter destination link"
                  />
                  <span class="is-invalid" v-if="fieldRequired.invalidLink"
                    >Invalid link.</span
                  >
                </div>
              </div>

              <div class="field-row">
                <div class="field-label">
                  Update order status without POS confirmation
                </div>
                <div class="field-value">
                  <div class="d-flex flex-wrap gap-3">
                    <MaterialRadio
                      value="1"
                      class="ps-0"
                      v-model="branch.update_order_status_without_pos"
                      >Yes</MaterialRadio
                    >
                    <MaterialRadio
                      value="0"
                      v-model="branch.update_order_status_without_pos"
                      >No</MaterialRadio
                    >
                  </div>
                </div>
              </div>

              <!-- ══════════════════════════════
                   CONFIRMATION NOTES
              ══════════════════════════════ -->
              <div class="section-heading"><h4>Confirmation Notes</h4></div>

              <div class="field-row">
                <div class="field-label">Note*</div>
                <div class="field-value">
                  <ckeditor
                    :editor="editor"
                    v-model="branch.note"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </div>
            <!-- /.form-fields -->
          </div>
        </div>
      </div>

      <!-- M986 follow-up: MOO Delivery slots / charge by distance (iMakan style). -->
      <ModalDeliverySlots ref="deliverySlots" :branchId="branch.id" />
      <ModalPriceSchedules ref="priceSchedules" :prices="prices" :branchId="branch.id" @saved="onPriceSchedulesSaved" />
      <ModalDeliveryChargeTiers ref="deliveryChargeTiers" :branchId="branch.id" />
      <ModalConfirm
        message="Are you sure you want to delete ?"
        :process-yes="processYes"
      />
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
      <add-period
        :keyReload="keyReload"
        :day="daySelect"
        @handle-add-period="handleAddPeriod"
      ></add-period>
    </div>
  </div>

  <!-- SH008 — Add Service Staff. A dialog rather than a dropdown: a salon chain can have
       hundreds of staff, so this searches and pages through them and assigns a tickbox
       selection in one go. -->
  <div
    v-if="isStaffPickerOpen"
    class="staff-picker-backdrop"
    @click.self="closeStaffPicker"
  >
    <div class="staff-picker" role="dialog" aria-modal="true" aria-label="Add service staff">
      <div class="staff-picker-head">
        <h5 class="mb-0">Add Service Staff</h5>
        <button
          type="button"
          class="staff-picker-close"
          aria-label="Close"
          @click="closeStaffPicker"
        >
          ✕
        </button>
      </div>

      <div class="staff-picker-search">
        <input
          v-model="pickerKeyword"
          type="search"
          class="form-control form-control-sm"
          placeholder="Search by name, job title or staff ID"
          @input="onPickerSearch"
        />
      </div>

      <div class="staff-picker-body">
        <label
          v-for="staff in pickerStaff"
          :key="staff.id"
          class="staff-picker-row"
        >
          <input
            type="checkbox"
            :value="staff.id"
            :checked="pickedIds.includes(staff.id)"
            @change="togglePicked(staff.id)"
          />
          <img
            v-if="staff.image"
            :src="staff.image"
            class="service-staff-avatar"
            :alt="staff.name"
          />
          <span v-else class="service-staff-avatar service-staff-avatar--blank">
            {{ (staff.name || "?").charAt(0).toUpperCase() }}
          </span>
          <span class="staff-picker-labels">
            <span class="service-staff-name">{{ staff.name }}</span>
            <span class="service-staff-title">{{ staff.job_title || "—" }}</span>
          </span>
        </label>

        <p v-if="!pickerStaff.length" class="fs-12 text-center py-3 mb-0">
          {{
            pickerKeyword
              ? "No staff match that search."
              : "Every staff member is already assigned to this channel."
          }}
        </p>
      </div>

      <div class="staff-picker-foot">
        <div class="d-flex gap-2 align-items-center">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary staff-picker-page mb-0"
            :disabled="pickerPage <= 1"
            @click="goPickerPage(pickerPage - 1)"
          >
            ‹
          </button>
          <span class="fs-12">Page {{ pickerPage }} of {{ pickerLastPage }}</span>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary staff-picker-page mb-0"
            :disabled="pickerPage >= pickerLastPage"
            @click="goPickerPage(pickerPage + 1)"
          >
            ›
          </button>
        </div>
        <div class="d-flex gap-2">
          <button
            type="button"
            class="btn btn-sm btn-primary mb-0"
            @click="closeStaffPicker"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-background mb-0"
            :disabled="!pickedIds.length"
            @click="addPickedStaff"
          >
            Add{{ pickedIds.length ? " " + pickedIds.length : "" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import { scheduleWhenFrom } from "@/config/priceSchedule";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import MaterialButton from "@/components/MaterialButton.vue";
import SettingStoreService from "../../../services/settingStore.service";
import BranchServiceStaffService from "../../../services/branchServiceStaff.service";
import SettingGrabFoodService from "../../../services/settingGrabFood.service";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalDeliverySlots from "@/components/ModalDeliverySlots.vue";
import ModalDeliveryChargeTiers from "@/components/ModalDeliveryChargeTiers.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import Multiselect from "@vueform/multiselect";
import AddPeriod from "../stores/ModelAddPeriod.vue";
import ModalPriceSchedules from "@/components/ModalPriceSchedules.vue";
import moment from "moment";
import $ from "jquery";
import ColorInput from "vue-color-input";
import PaymentService from "../../../services/payment.service";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import { scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "branch-detail",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    ModalConfirm,
    MaterialInput,
    Multiselect,
    ModalPriceSchedules,
    AddPeriod,
    MaterialRadio,
    ColorInput,
    MaterialCheckbox,
    ModalDeliverySlots,
    ModalDeliveryChargeTiers,
  },
  data() {
    return {
      message: "",
      // SF283 — Advocado outlets for the picker; empty when Advocado is not set up.
      advocadoOutlets: [],
      snackbar: null,
      loaderActive: false,
      // SH008 — service staff assigned to this sale channel. Paginated: a salon chain
      // can run to hundreds of staff.
      assignedStaff: [],
      assignedTotal: 0,
      assignedKeyword: "",
      assignedPage: 1,
      assignedLastPage: 1,
      assignedSearchTimer: null,
      // The Add dialog, which pages through the staff NOT yet assigned here.
      isStaffPickerOpen: false,
      pickerStaff: [],
      pickerKeyword: "",
      pickerPage: 1,
      pickerLastPage: 1,
      pickerSearchTimer: null,
      pickedIds: [],
      fieldRequired: {},
      textRequiredDateCustom: "",
      urlImagePreview: null,
      messageImageError: "",
      isErrorUploadImage: false,
      isSyncing: false,
      zeroPricedItems: [],
      overlappingMenusetHours: "",
      isImageTooSmall: false,
      branch: {
        grabfood_integration: 0,
        grabfood_store_id: "",
        id: null,
        physical_branch_id: null,
        hide_on_outlet_list: 0,
        branch_name: "",
        branch_code: "",
        branch_address: "",
        unit_no: "",
        postal_code: "",
        icon: null,
        address: "",
        status: 1,
        branch_id: "",
        branch_id_text: "",
        menuset_id: 0,
        menuset_ids: [],
        operation_days: [],
        destination_link: "",
        waiting_time_type: 1,
        waiting_time: 0,
        waiting_time_start: 0,
        waiting_time_end: 0,
        waiting_time_unit: 1,
        moo_color: "#f9dd4b",
        kiosk_card_color: "",
        qr_expiry_time: 60,
        qr_expiry_time_unit: 1,
        accept_payment_on_moo: "0",
        how_customer_make_payment: "1",
        update_order_status_without_pos: "0",
        show_unavailable_items_on_ordering_online: 1,
        show_special_instructions_on_ordering_online: 1,
        special_instructions_placeholder: "Enter here",
        show_landing_page_on_ordering_online: 1,
        moo_qr_redirect_page: 1,
        moo_after_login_page: 1,
        // SF263 - post-QR-scan item popup. SF294: up to 3 items slide on it; an
        // empty list means "the latest items added", the ordering app's fallback.
        promo_popup_enabled: 0,
        promo_popup_item_ids: [],
        // SF295 - the menu-page banner grid; nothing picked means no banner.
        menu_banner_rect_item_id: null,
        menu_banner_square_item_ids: [],
        login_required: 1,
        // SF284 - member login on the Queue QR sign-in page; on keeps today's form.
        queue_qr_member_login_enabled: 1,
        // SF285 - the same switch for the Table QR sign-in page.
        table_qr_member_login_enabled: 1,
        // M1051 - hide member Login and Rewards on MOO; off keeps them.
        hide_member_login_moo: 0,
        show_number_of_pax: 1,
        show_pickup_details: 0,
        show_contact_details: 0,
        show_delivery_contact_moo: 0,
        show_pickup_details_on_order_confirmation: 0,
        show_remark_on_order_confirmation: 0,
        show_note_on_order_confirmation: 0,
        show_dining_option_moo: 0,
        show_open_request_option_moo: 0,
        show_pickup_delivery_option_moo: 0,
        pickup_delivery_mode: 3,
        minimum_total_for_free_delivery_fee: 0,
        dining_location_moo: 1,
        takeaway_indicator: 2,
        payment_mode_moo: 1,
        main_item_default_price: "",
        main_item_member_price: "",
        modifier_default_price: "",
        modifier_member_price: "",
        grabfood_main_price: "",
        price_schedules: [],
        price_schedules_enabled: 0,
        stock_passcode: "",
        note: "",
        open_request_title: "",
        open_request_placeholder: "",
        allow_ewallet: 0,
        allow_paynow: 0,
        allow_creditcard: 0,
        pickup_notes: "",
        delivery_notes: "",
        delivery_fee_item_number: "",
        // M986 follow-up — MOO Delivery slots (days are dayOfWeek, 0 = Sunday).
        delivery_days: "0,1,2,3,4,5,6",
        delivery_minimum_order: 0,
        pickup_minimum_order: 0,
        delivery_advance_days: 7,
        delivery_cutoff_offset_hours: 0,
        delivery_fee_mode: 1,
        // M1004 — CBD surcharge on Lalamove deliveries.
        cbd_surcharge_enabled: 0,
        cbd_surcharge_amount: 0,
        cbd_postal_prefixes: "01,02,03,04,05,06,07,08",
        enable_bcrs: 0,
        each_bcrs_amount: 0.1,
        theme: 1,
        salon_theme: 0,
        // SH008 — the channel's default turnaround between two appointments.
        appointment_gap_min: 0,
        // SH026 — 1 date first, 2 staff first, 3 the customer chooses. 1 is the order MOO
        // ran before the setting existed, so a channel that never touches this keeps it.
        salon_booking_flow: 1,
        // SH031 — 0 no, 1 yes. Off by default, including for channels that were pushing
        // before this setting existed: a pay-later bill is real money on a real counter.
        salon_send_orders_to_pos: 0,
        // SH032 — 0 no, 1 yes. Off by default: a colour or a perm is quoted at the chair,
        // so the booking flow shows no price until the merchant asks for one.
        salon_show_service_price: 0,
        service_charge_on_discounted_subtotal: 0,
        allow_apply_voucher: 1,
        max_deduct_type: 1,
        max_deduct_value: 100,
      },
      branchCreateAt: "",
      branchCreateBy: "",
      menuset: [],
      waitingTime: [],
      // M986. Lalamove serviceType keys (SG market).
      lalamove: {
        is_enabled: 0,
        service_type: "MOTORCYCLE",
        sender_phone: "",
        api_key: "",
        api_secret: "",
        has_api_secret: false,
      },
      lalamoveServiceTypes: [
        // M986 follow-up: Lalamove SG calls the motorcycle service "Courier" - the default.
        { value: "MOTORCYCLE", label: "Courier (motorcycle, up to 8 kg)" },
        { value: "CAR", label: "Car" },
        { value: "VAN", label: "Van" },
        // M986 follow-up: not a Lalamove vehicle - the store delivers every order itself.
        { value: "OWN", label: "Own delivery (in-house)" },
      ],
      // M986 follow-up: dayOfWeek numbers as stored in branch.delivery_days.
      // Price Schedules: shown once the API returns them, so a portal deployed ahead of the
      // API never posts an empty list over schedules it could not load.
      priceSchedulesSupported: false,
      deliveryWeekDays: [
        { value: 1, label: "Mon" },
        { value: 2, label: "Tue" },
        { value: 3, label: "Wed" },
        { value: 4, label: "Thu" },
        { value: 5, label: "Fri" },
        { value: 6, label: "Sat" },
        { value: 0, label: "Sun" },
      ],
      periodType: [],
      physicalBranches: [],
      physicalBranchesConnectStripe: [],
      physicalBranchesConnectAllinpay: [],
      daySelect: 0,
      timeUnit: [
        { value: 1, label: "Minutes" },
        { value: 2, label: "Hours" },
        { value: 3, label: "Days" },
      ],
      stripe_access_token: "",
      stripe_refresh_token: "",
      stripe_user_id: "",
      allinpay_auth_mcht_id: "",
      prices: [],
      memberPrices: [],
      dining_locations: [
        { value: 0, label: "Both" },
        { value: 1, label: "Takeaway" },
        { value: 2, label: "Dine In" },
      ],
      // M920: mirrors MintyBranch::QR_REDIRECT_PAGE in minty.crm.api.
      qr_redirect_pages: [
        { value: 1, label: "Landing Page" },
        { value: 2, label: "Login / Guest Page" },
        { value: 3, label: "Ordering Page" },
        { value: 4, label: "Member Main Page" },
      ],
      // M921: mirrors MintyBranch::AFTER_LOGIN_PAGE in minty.crm.api.
      after_login_pages: [
        { value: 1, label: "Ordering Page" },
        { value: 2, label: "Member Main Page" },
        { value: 3, label: "My Rewards" },
      ],
      // SF263: items this sale channel may pin to the post-scan popup. Filled from
      // the API (published, in this channel's menu sets, not POS-only, available);
      // the leading entry keeps today's behaviour of showing the newest item.
      promoPopupItems: [],
      promoPopupIneligibleItems: [],
      // SF295: the channel's upsell items, the only ones the banner grid may use.
      menuBannerItems: [],
      menuBannerIneligibleItems: [],
      // SF295: one entry per banner slot image, keyed by its minty_branches column.
      // `url` is what is saved, `file` a new upload, `remove` a saved image cleared.
      menuBannerImages: {
        menu_banner_rect_image: { url: null, file: null, preview: null, remove: false },
        menu_banner_square1_image: { url: null, file: null, preview: null, remove: false },
        menu_banner_square2_image: { url: null, file: null, preview: null, remove: false },
      },
      menuBannerRectSlots: [
        {
          column: "menu_banner_rect_image",
          label: "Rectangle",
          hint: "Recommended 800 x 1200 px (2:3). Empty uses the dish image.",
        },
      ],
      menuBannerSquareSlots: [
        {
          column: "menu_banner_square1_image",
          label: "Top square",
          hint: "Recommended 800 x 800 px. Empty uses the dish image.",
        },
        {
          column: "menu_banner_square2_image",
          label: "Bottom square",
          hint: "Recommended 800 x 800 px. Empty uses the dish image.",
        },
      ],
      menuBannerImageError: "",
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "bold",
            "italic",
            "|",
            "undo",
            "redo",
          ],
        },
      },
      takeaway_indicator_types: [
        { value: 1, label: "As a Modifier for every item" },
        { value: 2, label: "As a Staff Name" },
      ],
      payment_modes: [
        { value: 1, label: "Stripe" },
        { value: 2, label: "AllInPay" },
        { value: 3, label: "Airwallex" },
        { value: 5, label: "Qlub" },
      ],
    };
  },
  computed: {
    // KSK105: the picker needs a colour to show, so an unset card colour reads as white,
    // and picking white clears it (white cards = no colour).
    kioskCardColorInput: {
      get() {
        return this.branch.kiosk_card_color || "#ffffff";
      },
      set(color) {
        this.branch.kiosk_card_color = color && color.toLowerCase() !== "#ffffff" ? color : "";
      },
    },
    // What the kiosk actually paints: the colour mixed 6% into white
    // (minty.crm.onlineordering kioskBackground()).
    kioskCardPreview() {
      const color = this.branch.kiosk_card_color || "";
      if (!/^#[0-9a-f]{6}$/i.test(color)) return "#ffffff";
      const mix = (i) =>
        Math.round(parseInt(color.slice(i, i + 2), 16) * 0.06 + 255 * 0.94)
          .toString(16)
          .padStart(2, "0");
      return `#${mix(1)}${mix(3)}${mix(5)}`;
    },
    // Special Scheduled Price button text: "Off" / "On · 2 schedules".
    priceScheduleSummary() {
      if (Number(this.branch.price_schedules_enabled) !== 1) {
        return "Off";
      }
      const count = (this.branch.price_schedules || []).filter((schedule) => schedule.status).length;
      return `On · ${count} schedule${count === 1 ? "" : "s"}`;
    },
    // SF283: only a Theme 2 channel orders through Advocado.
    isAdvocadoTheme() {
      return Number(this.branch.theme) === 2;
    },
    // SF305: an unpicked outlet silently books QR earn/redeem on the default store, so a
    // Theme 2 channel must pick one - but only once the list loaded: when Advocado is down
    // or the merchant is not on it there is nothing to pick, and the save must not block.
    advocadoOutletRequired() {
      return this.isAdvocadoTheme && this.advocadoOutlets.length > 0;
    },
    // SF283: a saved outlet missing from the list stays visible so it can be changed.
    // "Unlisted" only when the list did load - otherwise Advocado just did not answer.
    advocadoOutletOptions() {
      const options = this.advocadoOutlets.map((o) => ({ value: o.id, label: o.name }));
      const saved = this.branch.advocado_outlet_id;
      if (saved && !options.some((o) => o.value === saved)) {
        const label = options.length ? "Unlisted outlet (" + saved + ")" : saved;
        options.push({ value: saved, label });
      }
      return options;
    },
    // M995: with Pickup/Delivery selection on, the channel may offer only one of them.
    channelOffersPickup() {
      return !(this.branch.show_pickup_delivery_option_moo == 1 && this.branch.pickup_delivery_mode == 2);
    },
    channelOffersDelivery() {
      return !(this.branch.show_pickup_delivery_option_moo == 1 && this.branch.pickup_delivery_mode == 1);
    },
    // SF295: an item may sit in only one banner slot, so each picker leaves out what
    // the other one holds.
    menuBannerRectOptions() {
      const squares = this.branch.menu_banner_square_item_ids || [];
      return this.menuBannerItems.filter((item) => !squares.includes(item.value));
    },
    menuBannerSquareOptions() {
      const rect = this.branch.menu_banner_rect_item_id;
      return this.menuBannerItems.filter((item) => item.value !== rect);
    },
    // SF295: name the picked items the ordering app will leave off the banner.
    menuBannerItemWarning() {
      const picked = [
        this.branch.menu_banner_rect_item_id,
        ...(this.branch.menu_banner_square_item_ids || []),
      ].filter(Boolean);
      const ineligible = this.menuBannerIneligibleItems.filter((item) =>
        picked.includes(item.value)
      );

      if (!ineligible.length) {
        return "";
      }

      return (
        "Not shown on the banner right now (not an active upsell item of this channel, or disabled): " +
        ineligible.map((item) => item.label).join(", ") +
        "."
      );
    },
    // SF263/SF294: name the picked items the ordering app will leave out of the popup.
    // Follows the current tags, so removing a stale item clears its warning.
    promoPopupItemWarning() {
      const picked = this.branch.promo_popup_item_ids || [];
      const ineligible = this.promoPopupIneligibleItems.filter((item) =>
        picked.includes(item.value)
      );

      if (!ineligible.length) {
        return "";
      }

      return (
        "Not shown on the popup right now (unpublished, POS only, unavailable or outside this channel's menu set): " +
        ineligible.map((item) => item.label).join(", ") +
        (ineligible.length === picked.length
          ? ". The latest items are shown instead."
          : ".")
      );
    },
    // SH008 — staff can only be assigned to a channel that exists; a brand-new one has
    // no id to hang the assignment off yet.
    isExistingBranch() {
      return !!(this.$route.params.id ?? 0);
    },

    // Named for Stripe, but checks the gateway picked as MOO Payment Mode: an
    // AllInPay channel needs an AllInPay merchant ID, not a Stripe account.
    checkConnectStripe() {
      if (this.branch.payment_mode_moo == 2) {
        return (
          this.allinpay_auth_mcht_id ||
          this.physicalBranchesConnectAllinpay.includes(
            this.branch.physical_branch_id,
          )
        );
      }
      return (
        this.stripe_user_id ||
        this.physicalBranchesConnectStripe.includes(
          this.branch.physical_branch_id,
        )
      );
    },
    hasZeroPricedMainItem() {
      return this.zeroPricedItems.length > 0;
    },
    hasOverlappingMenusetHours() {
      return this.overlappingMenusetHours !== "";
    },
    hasGrabStoreId() {
      return String(this.branch.grabfood_store_id || "").trim() !== "";
    },
    // A Grab store row exists for this channel (as loaded): its Grab orders switch applies.
    isGrabStoreSaved() {
      const status = this.branch.grabfood_link_status;
      return !!status && status !== "not_linked";
    },
    // The API reports the link only for a saved channel (grabfood_link_status:
    // not_linked / revoked / pending / unrouted / verified). A saved Grab store ID is live
    // at once; revoked / pending / unrouted means it is not - menu sync is refused and
    // Grab orders cannot be turned on. grabfood_verified covers an API without link status.
    isGrabStorePendingVerification() {
      if (!this.branch.grabfood_store_id) return false;
      const status = this.branch.grabfood_link_status;
      return status ? ["revoked", "pending", "unrouted"].includes(status) : this.branch.grabfood_verified === false;
    },
    grabIntegrationDown() {
      return ["FAILED", "INACTIVE"].includes(this.branch.grabfood_integration_status);
    },
    grabLinkMessage() {
      if (!this.branch.grabfood_store_id) return "";
      const status = this.branch.grabfood_link_status;
      if (status === "revoked") {
        return "Minty support turned off GrabFood for this sales channel. Please contact Minty support.";
      }
      if (status === "pending" || (!status && this.branch.grabfood_verified === false)) {
        return "This GrabFood Store ID is not active. Click Save to activate it. If Minty support turned it off, please contact Minty support.";
      }
      if (status === "unrouted") {
        return "This GrabFood Store ID is not active for this sales channel. If it is also saved on another sales channel, remove it there first, then click Save here.";
      }
      if (status === "verified" && this.grabIntegrationDown) {
        return "Grab reports this store as " + this.branch.grabfood_integration_status + ". Fix any menu errors below and click Sync Menu again. If it stays " + this.branch.grabfood_integration_status + ", please contact Grab.";
      }
      if (status === "verified" && this.branch.grabfood_integration != 1 && this.branch.grabfood_integration_status === "ACTIVE" && !this.branch.grabfood_paused_on_grab) {
        return "Grab may still take orders that Minty will refuse. Turn Grab orders ON, or OFF again to pause the store on Grab, in GrabFood settings.";
      }
      return "";
    },
    zeroPricedItemNames() {
      var names = this.zeroPricedItems
        .slice(0, 5)
        .map((item) => item.item_no + " " + item.item_name)
        .join(", ");
      var remaining = this.zeroPricedItems.length - 5;
      return remaining > 0 ? names + " and " + remaining + " more" : names;
    },
  },
  watch: {
    hasGrabStoreId() {
      this.checkGrabMenuPrice();
    },
    "branch.grabfood_main_price"() {
      this.checkGrabMenuPrice();
    },
    "branch.menuset_ids": {
      handler() {
        this.checkGrabMenuPrice();
      },
      deep: true,
    },
  },
  created() {
    this.getStripeConnectInfoByMerchant();
    this.getBranchDetail();
    this.getLalamoveSetting();
    this.getAdvocadoOutlets();
  },
  mounted() {},
  methods: {
    // KSK109: a typed hex only lands once it is a full #rrggbb; a half-typed
    // value stays in the box and is reverted on blur.
    onHexInput(value, apply) {
      const hex = (value || "").trim().replace(/^#?/, "#");
      if (/^#[0-9a-f]{6}$/i.test(hex)) apply(hex.toLowerCase());
    },
    // SF283: a failure just leaves the picker hidden (or showing the saved id only).
    getAdvocadoOutlets() {
      SettingStoreService.getAdvocadoOutlets().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.advocadoOutlets = response.data.data.outlets || [];
          }
        },
        () => {},
      );
    },
    // M986: the Lalamove settings live in their own table (the secret must never reach
    // MOO with the branch row), so they load and save beside the branch, not inside it.
    getLalamoveSetting() {
      const branchId = this.$route.params.id ?? 0;
      if (!branchId) {
        return;
      }

      SettingStoreService.getLalamoveSetting(branchId).then((response) => {
        if (response.data.result.isSuccess) {
          this.lalamove = Object.assign({}, this.lalamove, response.data.data, {
            is_enabled: Number(response.data.data.is_enabled ?? 0),
            api_secret: "",
          });
        }
      });
    },
    // Resolves false (and shows why) when the settings were refused, so the
    // caller stays on the page instead of leaving with them unsaved.
    // M986 follow-up: branch.delivery_days is a comma list ("0,1,...,6", 0 = Sunday).
    deliveryDayList() {
      return String(this.branch.delivery_days ?? "")
        .split(",")
        .filter((day) => day !== "")
        .map(Number);
    },
    // The modal has already saved them; just keep what is stored.
    onPriceSchedulesSaved({ price_schedules, price_schedules_enabled }) {
      this.branch.price_schedules = this.normalisePriceSchedules(price_schedules);
      this.branch.price_schedules_enabled = Number(price_schedules_enabled ?? 0);
      this.snackbar = "success";
      this.message = "Price schedules saved";
      this.setTimeOutNotification();
    },
    normalisePriceSchedules(schedules) {
      return (schedules || []).map((schedule) => ({
        ...scheduleWhenFrom(schedule),
        price_key: schedule.price_key || null,
        status: Number(schedule.status ?? 1),
      }));
    },
    isDeliveryDay(day) {
      return this.deliveryDayList().includes(day);
    },
    toggleDeliveryDay(day, checked) {
      const days = this.deliveryDayList().filter((d) => d !== day);
      if (checked) {
        days.push(day);
      }
      this.branch.delivery_days = days.sort((a, b) => a - b).join(",");
    },
    saveLalamoveSetting() {
      if (!this.branch.id || this.branch.show_pickup_delivery_option_moo != 1) {
        return Promise.resolve(true);
      }

      return SettingStoreService.saveLalamoveSetting({
        branch_id: this.branch.id,
        is_enabled: this.lalamove.is_enabled,
        service_type: this.lalamove.service_type,
        sender_phone: this.lalamove.sender_phone,
        api_key: this.lalamove.api_key,
        api_secret: this.lalamove.api_secret,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            return true;
          }
          this.snackbar = "danger";
          this.message = "Lalamove: " + response.data.result.message;
          this.setTimeOutNotification();
          return false;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = "Lalamove: " + (error.response?.data?.result?.message ?? error.message);
          this.setTimeOutNotification();
          return false;
        }
      );
    },
    // SH008 — the channel's stylists, one page at a time.
    getServiceStaff() {
      const branchId = this.$route.params.id ?? 0;

      if (!branchId) {
        return;
      }

      BranchServiceStaffService.getList({
        branch_id: branchId,
        search_keyword: this.assignedKeyword,
        page: this.assignedPage,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.assignedStaff = data.items ?? [];
            // The full count, not the page: "40 assigned" is what the merchant needs to
            // know, and it is the number a page of 20 would otherwise hide.
            this.assignedTotal = data.assigned_total ?? 0;
            this.assignedPage = data.current_page ?? 1;
            this.assignedLastPage = data.last_page ?? 1;
          }
        },
        () => {
          this.assignedStaff = [];
          this.assignedTotal = 0;
        }
      );
    },

    onAssignedSearch() {
      clearTimeout(this.assignedSearchTimer);
      this.assignedSearchTimer = setTimeout(() => {
        this.assignedPage = 1;
        this.getServiceStaff();
      }, 500);
    },

    goAssignedPage(page) {
      if (page < 1 || page > this.assignedLastPage) {
        return;
      }

      this.assignedPage = page;
      this.getServiceStaff();
    },

    openStaffPicker() {
      this.isStaffPickerOpen = true;
      this.pickerKeyword = "";
      this.pickerPage = 1;
      this.pickedIds = [];
      this.getPickerStaff();
    },

    closeStaffPicker() {
      this.isStaffPickerOpen = false;
      this.pickedIds = [];
    },

    getPickerStaff() {
      const branchId = this.$route.params.id ?? 0;

      if (!branchId) {
        return;
      }

      BranchServiceStaffService.getAvailable({
        branch_id: branchId,
        search_keyword: this.pickerKeyword,
        page: this.pickerPage,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.pickerStaff = data.items ?? [];
            this.pickerPage = data.current_page ?? 1;
            this.pickerLastPage = data.last_page ?? 1;
          }
        },
        () => {
          this.pickerStaff = [];
        }
      );
    },

    onPickerSearch() {
      clearTimeout(this.pickerSearchTimer);
      this.pickerSearchTimer = setTimeout(() => {
        this.pickerPage = 1;
        this.getPickerStaff();
      }, 500);
    },

    goPickerPage(page) {
      if (page < 1 || page > this.pickerLastPage) {
        return;
      }

      this.pickerPage = page;
      this.getPickerStaff();
    },

    // Ticks survive paging and searching inside the dialog, so a merchant can gather a
    // selection across pages and add it in one go.
    togglePicked(staffId) {
      const index = this.pickedIds.indexOf(staffId);

      if (index === -1) {
        this.pickedIds.push(staffId);
      } else {
        this.pickedIds.splice(index, 1);
      }
    },

    // Add and Remove persist immediately rather than waiting for the branch's Save.
    // With a paginated list there is no whole list to submit, and deferring would mean
    // holding an unbounded pending diff in the page.
    addPickedStaff() {
      const branchId = this.$route.params.id ?? 0;

      if (!branchId || !this.pickedIds.length) {
        return;
      }

      this.showLoader();
      BranchServiceStaffService.add(branchId, this.pickedIds).then(
        (response) => {
          this.hideLoader();

          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Service staff added";
            this.closeStaffPicker();
            this.getServiceStaff();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }

          this.setTimeOutNotification();
        },
        (error) => {
          this.hideLoader();
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },

    removeServiceStaff(staff) {
      const branchId = this.$route.params.id ?? 0;

      if (!branchId) {
        return;
      }

      this.showLoader();
      BranchServiceStaffService.remove(branchId, [staff.id]).then(
        (response) => {
          this.hideLoader();

          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Service staff removed";
            // Coming back to an emptied last page would show nothing at all.
            if (this.assignedStaff.length === 1 && this.assignedPage > 1) {
              this.assignedPage -= 1;
            }
            this.getServiceStaff();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }

          this.setTimeOutNotification();
        },
        (error) => {
          this.hideLoader();
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },
ndleFileUpload(event) {
      this.isImageTooSmall = false;
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        this.branch.icon = null;
        this.urlImagePreview = null;
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type,
          )
        ) {
          this.fieldRequired.isImageRequire = true;
          this.isErrorUploadImage = false;
          this.messageImageError = `File must be an image.`;
        } else {
          const maxFileSize = 1024 * 1024;
          if (file.size > maxFileSize) {
            this.fieldRequired.isImageRequire = true;
            this.messageImageError = `File size must not exceed 1MB.`;
            return;
          }
          this.branch.icon = file;
          this.urlImagePreview = URL.createObjectURL(this.branch.icon);
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              if (width < 200 || height < 115) {
                this.messageImageError = `The image width ${width} x ${height} is too small.`;
                this.fieldRequired.isImageRequire = true;
                this.isErrorUploadImage = true;
                this.isImageTooSmall = true;
              } else {
                this.fieldRequired.isImageRequire = false;
                this.isErrorUploadImage = false;
                this.isImageTooSmall = false;
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        this.branch.icon = null;
        this.urlImagePreview = null;
        this.fieldRequired.isImageRequire = true;
        this.isErrorUploadImage = false;
        this.messageImageError = `File must be an image.`;
      }
    },
    clearImage() {
      this.branch.icon = null;
      this.urlImagePreview = null;
      this.fieldRequired.isImageRequire = false;
      this.isErrorUploadImage = false;
      this.isImageTooSmall = false;
    },
    timeFormat(time) {
      if (time == null) {
        return null;
      } else {
        return moment(time).format("H:m");
      }
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    addPeriod(day) {
      this.daySelect = day;
      this.keyReload = Math.random();
      $("#show-modal-add-period").click();
    },
    removePeriod(index, index2) {
      this.branch.operation_days[index].operation_hours.splice(index2, 1);
    },
    handleAddPeriod(index, start_time, end_time) {
      this.branch.operation_days[index].operation_hours.push({
        branch_id: this.branch.branch_id,
        day_of_week: this.branch.operation_days[index].day_of_week,
        start_time: start_time,
        end_time: end_time,
        start_time_format: start_time,
        end_time_format: end_time,
      });
    },
    changeStatus() {
      var branchId = this.$route.params.id ?? 0;
      this.showLoader();
      SettingStoreService.changeStatus(branchId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Change Status Success";
            this.getBranchDetail();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.hideLoader();
          this.setTimeOutNotification();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        },
      );
    },
    getBranchDetail() {
      var branchId = this.$route.params.id ?? 0;
      this.showLoader();
      SettingStoreService.getDataBranchDetail(branchId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const branchData = response.data.data.branch;
            this.branch = Object.assign({}, this.branch, branchData);
            // Price Schedules - an API without them leaves the section hidden and unsent.
            this.priceSchedulesSupported = Array.isArray(branchData.price_schedules);
            this.branch.price_schedules = this.normalisePriceSchedules(branchData.price_schedules);
            // The radios compare with ===; a tenant without the column reads as off.
            this.branch.price_schedules_enabled = Number(branchData.price_schedules_enabled ?? 0);
            // M1004 — the Yes/No radios compare with ===.
            this.branch.cbd_surcharge_enabled = Number(branchData.cbd_surcharge_enabled ?? 0);
            // SH008 — a channel that has never had a gap set comes back null; the number
            // box needs 0 rather than an empty string it would then post back as "".
            this.branch.appointment_gap_min = Number(
              branchData.appointment_gap_min ?? 0
            );
            // SH026 — the radios compare with ===, and a channel saved before this column
            // existed comes back null. Number() also settles the string a tinyint can
            // arrive as, which would otherwise leave all three radios unchecked.
            this.branch.salon_booking_flow =
              Number(branchData.salon_booking_flow) || 1;
            // SH031 — same reason, except the fallback is 0: a channel saved before this
            // column existed has never asked for POS bills and must not start getting them.
            this.branch.salon_send_orders_to_pos = Number(
              branchData.salon_send_orders_to_pos ?? 0
            );
            // SH032 — same again: a channel saved before this column existed has never
            // quoted a price online, and reopening its settings must not start it.
            this.branch.salon_show_service_price = Number(
              branchData.salon_show_service_price ?? 0
            );
            // SF263 - a channel that has never had a popup item pinned comes back
            // with an empty list; the picker shows "latest items added" for it.
            this.branch.promo_popup_enabled = Number(
              branchData.promo_popup_enabled ?? 0
            );
            this.branch.promo_popup_item_ids = (
              branchData.promo_popup_item_ids || []
            ).map(Number);
            this.hydratePromoPopupItems(branchData.promo_popup_items || []);
            // SF295 - the banner grid; a channel saved before it comes back empty.
            this.branch.menu_banner_rect_item_id =
              Number(branchData.menu_banner_rect_item_id) || null;
            this.branch.menu_banner_square_item_ids = (
              branchData.menu_banner_square_item_ids || []
            ).map(Number);
            this.hydrateMenuBanner(branchData);
            // SF284 - the column defaults to on, so a missing value means on too.
            this.branch.queue_qr_member_login_enabled = Number(
              branchData.queue_qr_member_login_enabled ?? 1
            );
            // SF285 - same for Table QR.
            this.branch.table_qr_member_login_enabled = Number(
              branchData.table_qr_member_login_enabled ?? 1
            );
            // M1051 - the column defaults to off.
            this.branch.hide_member_login_moo = Number(
              branchData.hide_member_login_moo ?? 0
            );
            this.getServiceStaff();
            if (!this.branch.branch_address && this.branch.address) {
              this.branch.branch_address = this.branch.address;
            }
            if (this.branch.note == null) {
              this.branch.note = "";
            }
            if (this.branch.minimum_total_for_free_delivery_fee == "0.00") {
              this.branch.minimum_total_for_free_delivery_fee = 0;
            }
            this.menuset = response.data.data.menusetDropdown;
            this.waitingTime = response.data.data.waitingTimeDropdown;
            this.physicalBranches = response.data.data.physicalBranchesDropdown;
            this.physicalBranchesConnectStripe =
              response.data.data.physicalBranchesConnectStripe;
            this.physicalBranchesConnectAllinpay =
              response.data.data.physicalBranchesConnectAllinpay || [];
            this.branchCreateAt = response.data.data.create_at;
            this.branchCreateBy = response.data.data.create_by;
            this.periodType = response.data.data.period_type;
            this.prices = response.data.data.pricesDropdown;
            this.memberPrices = response.data.data.pricesDropdown;
            this.memberPrices.unshift({ value: 0, label: "None" });
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        },
      );
    },
    // SF263: seed the picker with the items this channel already has pinned, so the
    // tags show names before the option list has been fetched - and say which of them
    // have stopped qualifying (deleted, unpublished, POS-only or unavailable), because
    // the ordering app leaves those out of the popup (SF294), or falls back to the
    // latest items when none is left.
    hydratePromoPopupItems(pinned) {
      this.promoPopupItems = pinned.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      this.promoPopupIneligibleItems = pinned.filter(
        (item) => !item.is_eligible
      );
    },
    // SF263: options for the popup item picker. The API already filters the list, so
    // Multiselect is told not to filter again (:filterResults="false") - typing refetches.
    getPromoPopupItems(search = "") {
      const keyword = typeof search === "string" ? search : "";

      SettingStoreService.getPromoPopupItems({
        branch_id: this.$route.params.id || 0,
        menuset_ids: this.branch.menuset_ids || [],
        physical_branch_id: this.branch.physical_branch_id || 0,
        search: keyword,
      }).then(
        (response) => {
          if (!response.data.result.isSuccess) {
            return;
          }

          const options = [...(response.data.data.list || [])];

          // Keep every picked item in the list even when it no longer qualifies or falls
          // outside the current search, otherwise its tag would lose its label.
          (this.branch.promo_popup_item_ids || []).forEach((pickedId) => {
            if (options.some((option) => option.value === pickedId)) {
              return;
            }

            const picked = this.promoPopupItems.find(
              (option) => option.value === pickedId
            );

            if (picked) {
              options.push(picked);
            }
          });

          this.promoPopupItems = options;
        },
        () => {
          // list stays as it is - the merchant can still save the current selection
        },
      );
    },
    // SF295: seed both pickers with the saved items so they show names before the
    // option list is fetched, and each slot image with its saved URL.
    hydrateMenuBanner(branchData) {
      const pinned = [
        branchData.menu_banner_rect_item,
        ...(branchData.menu_banner_square_items || []),
      ].filter(Boolean);

      this.menuBannerItems = pinned.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      this.menuBannerIneligibleItems = pinned.filter((item) => !item.is_eligible);

      Object.keys(this.menuBannerImages).forEach((column) => {
        this.menuBannerImages[column] = {
          url: branchData[column + "_url"] || null,
          file: null,
          preview: null,
          remove: false,
        };
      });
    },
    // SF295: options for both banner pickers - the channel's upsell items. The API
    // already filters, so Multiselect does not filter again; typing refetches.
    getMenuBannerItems(search = "") {
      const keyword = typeof search === "string" ? search : "";

      SettingStoreService.getMenuBannerItems({
        branch_id: this.$route.params.id || 0,
        menuset_ids: this.branch.menuset_ids || [],
        search: keyword,
      }).then(
        (response) => {
          if (!response.data.result.isSuccess) {
            return;
          }

          const options = [...(response.data.data.list || [])];
          const picked = [
            this.branch.menu_banner_rect_item_id,
            ...(this.branch.menu_banner_square_item_ids || []),
          ].filter(Boolean);

          // Keep the picked items listed even when they no longer qualify or fall
          // outside the search, otherwise they would lose their labels.
          picked.forEach((pickedId) => {
            if (options.some((option) => option.value === pickedId)) {
              return;
            }

            const known = this.menuBannerItems.find(
              (option) => option.value === pickedId
            );

            if (known) {
              options.push(known);
            }
          });

          this.menuBannerItems = options;
        },
        () => {
          // list stays as it is - the merchant can still save the current selection
        },
      );
    },
    menuBannerImagePreview(column) {
      const image = this.menuBannerImages[column];
      return image.preview || (image.remove ? null : image.url);
    },
    pickMenuBannerImage(column) {
      const el = document.getElementById("menu-banner-file-" + column);
      if (el) {
        el.value = "";
        el.click();
      }
    },
    // SF295: the backend keeps jpg/png/gif/webp only (no SVG) and takes up to 10MB.
    onMenuBannerImageChange(column, event) {
      const file = event.target.files && event.target.files[0];
      this.menuBannerImageError = "";

      if (!file) {
        return;
      }

      if (!["image/png", "image/jpeg", "image/gif", "image/webp"].includes(file.type)) {
        this.menuBannerImageError = "Banner image must be a JPG, PNG, GIF or WEBP file.";
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        this.menuBannerImageError = "Banner image must not exceed 10MB.";
        return;
      }

      const image = this.menuBannerImages[column];
      image.file = file;
      image.preview = URL.createObjectURL(file);
      image.remove = false;
    },
    clearMenuBannerImage(column) {
      const image = this.menuBannerImages[column];
      image.file = null;
      image.preview = null;
      image.remove = !!image.url;
      this.menuBannerImageError = "";
    },
    // SF295: what the save posts for the banner. The rectangle goes as 0 when empty
    // (axios leaves null fields out of multipart), the squares as a comma list for
    // the same reason as the popup items, and each image as a file or a remove flag.
    menuBannerPayload() {
      const payload = {
        menu_banner_rect_item_id: this.branch.menu_banner_rect_item_id || 0,
        menu_banner_square_item_ids: (
          this.branch.menu_banner_square_item_ids || []
        ).join(","),
      };

      Object.keys(this.menuBannerImages).forEach((column) => {
        const image = this.menuBannerImages[column];
        if (image.file) {
          payload[column + "_file"] = image.file;
        } else if (image.remove) {
          payload[column + "_remove"] = 1;
        }
      });

      return payload;
    },
    saveBranch() {
      var page = this.$route.query.page;
      if (this.isImageTooSmall) {
        this.isErrorUploadImage = true;
        this.fieldRequired.isImageRequire = true;
      } else {
        this.fieldRequired.isImageRequire = false;
      }
      this.showLoader();
      if (this.processValidate() && !this.isErrorUploadImage) {
        if (!this.checkConnectStripe) {
          this.branch.accept_payment_on_moo = 0;
          this.branch.how_customer_make_payment = 0;
        }
        // SF294: the popup items travel as a comma list - multipart drops an empty
        // array entirely, so clearing the picker would otherwise never be saved.
        SettingStoreService.addOrUpdateBranch({
          ...this.branch,
          promo_popup_item_ids: (this.branch.promo_popup_item_ids || []).join(","),
          // SF283: a cleared picker is null, which multipart would not send at all; any
          // theme but 2 holds no outlet (the API clears it too).
          advocado_outlet_id: this.isAdvocadoTheme ? this.branch.advocado_outlet_id || "" : "",
          // KSK105: "" (not null, which multipart drops) so "Reset to white" is saved.
          kiosk_card_color: this.branch.kiosk_card_color || "",
          ...this.menuBannerPayload(),
          // Special Scheduled Price is saved by its own modal; keep it out of this payload.
          price_schedules: undefined,
          price_schedules_enabled: undefined,
        }).then(
          (response) => {
            if (response.data.result.isSuccess) {
              // M986: after the branch, so a postal code typed in the same edit is
              // already saved when the Lalamove pickup point is checked.
              this.saveLalamoveSetting().then((lalamoveSaved) => {
                if (!lalamoveSaved) {
                  return;
                }
                this.snackbar = "success";
                this.message = "Save Branch Success";
                this.hideLoader();
                this.setTimeOutNotification();
                setTimeout(() => {
                  if (page) {
                    this.$router.push("/branches?page=" + page);
                  } else {
                    this.$router.push("/branches");
                  }
                }, 1000);
              });
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          },
        );
      } else {
        this.hideLoader();
      }
    },
    resetRequired() {
      this.fieldRequired.isPhysicalBranchRequire = false;
      this.fieldRequired.isBranchNameRequire = false;
      this.fieldRequired.isDateRequire = false;
      this.fieldRequired.isBranchCodeRequire = false;
      this.fieldRequired.isMenusetRequire = false;
      this.fieldRequired.invalidLink = false;
      this.fieldRequired.invalidMaxDeductValue = false;
      this.fieldRequired.isAdvocadoOutletRequire = false;
    },
    processValidate() {
      this.resetRequired();
      var isValid = true;
      if (
        this.branch.physical_branch_id == "" ||
        this.branch.physical_branch_id == null
      ) {
        this.fieldRequired.isPhysicalBranchRequire = true;
        isValid = false;
      }
      if (this.branch.branch_name == "" || this.branch.branch_name == null) {
        this.fieldRequired.isBranchNameRequire = true;
        isValid = false;
      }
      if (this.branch.branch_code == "" || this.branch.branch_code == null) {
        this.fieldRequired.isBranchCodeRequire = true;
        isValid = false;
      }
      if (!this.branch.menuset_ids || this.branch.menuset_ids.length == 0) {
        this.fieldRequired.isMenusetRequire = true;
        isValid = false;
      }
      if (this.advocadoOutletRequired && !this.branch.advocado_outlet_id) {
        this.fieldRequired.isAdvocadoOutletRequire = true;
        isValid = false;
      }
      if (
        this.branch.max_deduct_value === "" ||
        this.branch.max_deduct_value === null ||
        isNaN(this.branch.max_deduct_value) ||
        Number(this.branch.max_deduct_value) < 0
      ) {
        this.fieldRequired.invalidMaxDeductValue = true;
        isValid = false;
      }
      if (
        this.branch.destination_link != "" &&
        this.branch.destination_link != null
      ) {
        var urlRegex =
          "^(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$";
        var urlPattern = new RegExp(urlRegex, "i");
        if (!urlPattern.test(this.branch.destination_link)) {
          isValid = false;
          this.fieldRequired.invalidLink = true;
        }
      }
      // M986 follow-up: delivery needs at least one day, and hours that make a slot.
      if (this.branch.show_pickup_delivery_option_moo == 1 && this.channelOffersDelivery) {
        let deliveryError = "";
        if (this.deliveryDayList().length == 0) {
          deliveryError = "Please select at least one delivery day.";
        }
        // M1004: a CBD surcharge needs an amount and a valid sector list.
        if (!deliveryError && this.branch.cbd_surcharge_enabled == 1) {
          this.branch.cbd_postal_prefixes = String(this.branch.cbd_postal_prefixes || "").replace(/\s+/g, "");
          if (!(parseFloat(this.branch.cbd_surcharge_amount) > 0)) {
            deliveryError = "Please enter the CBD surcharge amount.";
          } else if (!/^\d{2}(,\d{2})*$/.test(this.branch.cbd_postal_prefixes)) {
            deliveryError = "CBD postal sectors must be 2-digit numbers separated by commas, e.g. 01,02,03.";
          }
        }
        if (deliveryError) {
          this.snackbar = "danger";
          this.message = deliveryError;
          this.setTimeOutNotification();
          isValid = false;
        }
      }
      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },
    checkGrabMenuPrice() {
      var branchId = this.$route.params.id ?? 0;
      if (!branchId || !this.hasGrabStoreId) {
        this.zeroPricedItems = [];
        this.overlappingMenusetHours = "";
        return;
      }
      SettingGrabFoodService.checkMenuPrice(
        branchId,
        this.branch.grabfood_main_price,
      ).then(
        (response) => {
          var data = response.data.result.isSuccess ? response.data.data : {};
          this.zeroPricedItems = data.items ?? [];
          this.overlappingMenusetHours =
            data.overlapping_menuset_hours_message ?? "";
        },
        () => {
          this.zeroPricedItems = [];
          this.overlappingMenusetHours = "";
        },
      );
    },
    syncGrabMenu() {
      if (!this.branch.grabfood_store_id) return;
      this.isSyncing = true;
      this.showLoader();
      SettingGrabFoodService.syncMenu(this.branch.grabfood_store_id).then(
        (response) => {
          this.isSyncing = false;
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = response.data.data.message || "Menu sync triggered";
            this.setTimeOutNotification();
            this.getBranchDetail();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.isSyncing = false;
          this.snackbar = "danger";
          this.message = error?.response?.data?.result?.message || error?.message || "Sync failed";
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    backBanchesList() {
      var page = this.$route.query.page;
      if (page) {
        this.$router.push("/branches" + "?page=" + page);
      } else {
        this.$router.push("/branches");
      }
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    uploadFile() {
      $("#image").click();
    },
    branchStockUrl(url) {
      return url;
    },
    getStripeConnectInfoByMerchant() {
      PaymentService.getStripeConnectInfoByMerchant().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.stripe_access_token =
              response.data.data.merchant_admin.stripe_access_token;
            this.stripe_refresh_token =
              response.data.data.merchant_admin.stripe_refresh_token;
            this.stripe_user_id =
              response.data.data.merchant_admin.stripe_user_id;
            this.allinpay_auth_mcht_id =
              response.data.data.merchant_admin.auth_mcht_id;
          }
          this.hideLoader();
        },
        (error) => {
          console.log(error);
        },
      );
    },
    changeAllowPayNow(value = 0) {
      if (typeof value == "boolean") {
        this.branch.allow_paynow = value ? 1 : 0;
      }
    },
    changeAllowCreditCard(value = 0) {
      if (typeof value == "boolean") {
        this.branch.allow_creditcard = value ? 1 : 0;
      }
    },
    changeAllowPaymentByMintyWallet(value = 0) {
      if (typeof value == "boolean") {
        this.branch.allow_ewallet = value ? 1 : 0;
      }
    },
  },
};
</script>

<style scoped>
/* SF295 - banner slot images: a 2:3 rectangle and two squares, each with its hint. */
.menu-banner-images {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
}

.menu-banner-image {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  max-width: 200px;
}

.menu-banner-image__preview {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  border: 1px dashed #ccc;
  border-radius: 6px;
  background: #f8f9fa;
  color: #999;
}

.menu-banner-image__preview--rect {
  aspect-ratio: 2 / 3;
}

.menu-banner-image__preview--square {
  aspect-ratio: 1 / 1;
}

.menu-banner-image__preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.menu-banner-image__remove {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #f44335;
  font-size: 18px;
  cursor: pointer;
}

.menu-banner-image .upload-size-hint {
  font-size: 12px;
  color: #7b809a;
}
/* ── Existing styles (unchanged) ── */
.text-back {
  color: black !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  font-family: "Roboto Slab", sans-serif !important;
}
#preview img {
  max-width: 168px;
  max-height: 115px;
}
.branch-address {
  width: 600px !important;
  max-width: 600px;
}
.menuset-select {
  max-width: 600px;
  margin-left: 0px;
}
.autocomplete-custom {
  cursor: pointer;
  position: absolute;
  z-index: 999;
}
.branch-autocomplete ul {
  padding: 0px !important;
  margin: 0px !important;
}
.branch-autocomplete li {
  height: 40px;
  text-transform: lowercase;
  padding-left: 10px;
  padding-right: 10px;
  letter-spacing: 1px;
  border-bottom: 1px solid #e1e3e4;
  font-size: 14px;
}
.mw-150px {
  max-width: 150px !important;
}
.fs-12 {
  font-size: 12px !important;
}
.fs-14 {
  font-size: 14px !important;
}

/* ── New layout styles ── */
.form-fields {
  width: 100%;
  /* Prevent any child from breaking out of the container */
  overflow: hidden;
}

/* ─────────────────────────────────────────
   FIELD ROW
   Mobile-first: stack vertically always.
   Two-column only on large screens (≥1024px).
───────────────────────────────────────── */
.field-row {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  gap: 6px;
}

.field-label {
  font-size: 14px;
  color: #344767;
  font-weight: 500;
  flex-shrink: 0;
  padding-top: 4px;
}

.field-value {
  flex: 1;
  min-width: 0; /* critical: prevent flex child overflow */
  max-width: 100%;
}

/* KSK109: hex box next to a colour picker — white text on a dark box. */
.hex-input {
  width: 96px;
  padding: 4px 8px;
  border: 1px solid #333333;
  border-radius: 6px;
  background: #333333;
  font-family: monospace;
  color: #ffffff;
}
.hex-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.hex-input:focus {
  outline: none;
  border-color: #ffffff;
}

/* KSK105: the tinted card colour as the kiosk shows it. */
.kiosk-card-preview {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border: 1px solid #e2e6df;
  border-radius: 8px;
  color: #141a14;
  font-size: 14px;
  font-weight: 500;
}

/* Two-column layout only on large desktop (≥1024px) */
@media (min-width: 1024px) {
  .field-row {
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
  }
  .field-label {
    width: 50vh;
    max-width: 50vh;
  }
}

/* Indented rows for sub-settings */
.field-row--indented .field-label {
  padding-left: 12px;
}
.field-row--indented2 .field-label {
  padding-left: 24px;
}

/* ─────────────────────────────────────────
   SECTION / SUBSECTION HEADINGS
───────────────────────────────────────── */
.section-heading {
  padding: 16px 0 4px;
}
.section-heading h4 {
  margin: 0;
}
.subsection-heading {
  padding: 10px 0 2px;
}
.subsection-heading h6 {
  margin: 0;
  padding-left: 4px;
}

/* ─────────────────────────────────────────
   OVERRIDE: branch-address & menuset-select
   Must fill available space on tablet/mobile.
───────────────────────────────────────── */
@media (max-width: 1023px) {
  .branch-address {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .menuset-select {
    max-width: 100% !important;
    width: 100% !important;
  }
  /* Ensure material-input fills width */
  .field-value .branch-address input,
  .field-value .branch-address {
    width: 100% !important;
    max-width: 100% !important;
  }

  .field-value .table-responsive table {
    min-width: 360px !important;
  }

  .text-back {
    margin-top: 10px;
    margin-left: 10px;
  }
}

/* ─────────────────────────────────────────
   PRICE LIST LAYOUT
───────────────────────────────────────── */
.price-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.price-row__label {
  flex-shrink: 0;
  padding-top: 6px;
  font-weight: 500;
}
.price-row__inputs {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}
.price-input-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.price-sublabel {
  font-size: 12px;
  color: #888;
  font-weight: 500;
}
.price-select {
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 1024px) {
  .price-row {
    flex-direction: row;
    align-items: flex-start;
  }
  .price-row__label {
    min-width: 110px;
    max-width: 110px;
  }
  .price-row__inputs {
    flex-direction: row;
    gap: 12px;
  }
  .price-input-group {
    min-width: 180px;
    max-width: 220px;
  }
  .price-select {
    max-width: 220px !important;
  }
}

/* Special Scheduled Price: button after Member Price (settings live in ModalPriceSchedules). */
.price-schedule-btn {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 6px;
  height: 34px;
  /* centred on the 42px selects beside it */
  margin-top: 4px;
  white-space: nowrap;
}
/* .btn-sm shrinks icons. */
.price-schedule-btn .price-schedule-btn__icon {
  font-size: 18px !important;
}
.price-schedule-btn__state {
  padding: 2px 8px;
  border-radius: 10px;
  background: #e9ecef;
  color: #67748e;
  font-size: 11px;
  text-transform: none;
}
.price-schedule-btn__state--on {
  background: #4caf50;
  color: #fff;
}

/* ─────────────────────────────────────────
   OPERATING HOURS TABLE
   Scroll horizontally instead of overflow.
───────────────────────────────────────── */
.field-value .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}

/* ─────────────────────────────────────────
   SMALL NUMBER INPUTS
───────────────────────────────────────── */
.w-input-sm {
  max-width: 160px;
}

/* SH008 — service staff list */
.service-staff-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.service-staff-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.service-staff-avatar {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 50%;
}

.service-staff-avatar--blank {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9ecef;
  color: #5b848d;
  font-weight: 600;
}

.service-staff-body {
  flex: 1;
  min-width: 0;
}

.service-staff-name {
  font-size: 14px;
  font-weight: 500;
}

.service-staff-title {
  font-size: 12px;
  color: #5b848d;
}

.service-staff-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.service-staff-search {
  max-width: 260px;
  border: 1px solid #dee2e6 !important;
  border-radius: 6px;
  padding: 6px 10px;
  background-color: #fff;
}

/* SH008 — Add Service Staff dialog. Hand-rolled rather than a Bootstrap modal: this
   section sits deep inside the branch form, and a Bootstrap modal would move focus and
   add its own scroll-lock padding to a page that is already one long scroll. */
.staff-picker-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1080;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.4);
}

.staff-picker {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.staff-picker-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #dee2e6;
}

/* The portal's global .btn stretches a button to fill its slot, which turns a one-glyph
   control into a 130px slab. These two need to stay the size of their glyph. */
.staff-picker-close {
  padding: 0 4px;
  font-size: 16px;
  line-height: 1;
  color: #344767;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.staff-picker-page {
  min-width: 0;
  width: 32px;
  padding: 2px 0 !important;
}

.staff-picker-search {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f3f5;
}

.staff-picker-body {
  flex: 1;
  min-height: 120px;
  padding: 8px 16px;
  overflow-y: auto;
}

.staff-picker-row {
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 8px 4px;
  margin: 0;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f5;
}

.staff-picker-row:last-child {
  border-bottom: 0;
}

.staff-picker-row input {
  flex-shrink: 0;
  margin: 0;
}

.staff-picker-labels {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.staff-picker-foot {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid #dee2e6;
}

/* Operating Hours table specific */
.op-hours-table {
  min-width: 360px;
  width: 100%;
}
.op-hours-table .multiselect {
  min-width: 130px;
}

.page-header {
  overflow-x: hidden;
}
.container-fluid {
  overflow-x: hidden;
}
</style>
